/**
 * @ Author: Housefolios
 * @ Create Time: 2021-10-27 15:01:56
 * @ Modified by: David Helmick
 * @ Modified time: 2025-12-17 17:00:53
 * @ Description: BRRRR Strategy Analysis page
 */

import React, { Suspense, lazy, useEffect, useState } from 'react'
import {
  strategyBadgeIconSx,
  strategyBlockSpacerSx,
  strategyCardBodyPadSx,
  strategyCardTitleSx,
  strategyCircleGreenAvatarSx,
  strategyFieldLabelSx,
  strategyFlexCenterOnlySx,
  strategyFlexCenterRowSx,
  strategyFlexCenterSx,
  strategyFlexGrowSx,
  strategyFlexPadSx,
  strategyFooterNoteSx,
  strategyFullHeight100Sx,
  strategyFullWidthHiddenSx,
  strategyFullWidthSx,
  strategyIconGap20Style,
  strategyIconGap5Style,
  strategyIconGapStyle,
  strategyMarginBottom10Sx,
  strategyMarginBottom5Sx,
  strategyMarginTop25Sx,
  strategyMaxHeight440Sx,
  strategyMetricDotBlueSx,
  strategyMetricDotGreenSx,
  strategyMetricDotRedSx,
  strategyMetricGrayBgSx,
  strategyMetricRowFlexSx,
  strategyMetricRowSx,
  strategyMinHeight50Sx,
  strategyMutedDividerSx,
  strategyMutedTextSx,
  strategyNavyBgSx,
  calcDialogPaperSx,
  strategyPad5Sx,
  strategyPadVert15Sx,
  strategySectionLabelSx,
  strategySubtitleCenterSx,
  strategyTableCellRightSx,
  strategyTableRowLastSx,
  strategyTableRowSx,
  strategyTooltipLinkSx,
  strategyUppercaseMetaSx,
  strategyWhiteTextSx,
} from '@/housefolios-components/PropertyContainer/CenterPage/Common/strategyDashboardSx'
import { useQuery } from '@apollo/client/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'

import CountUp from '@/utils/SafeCountUp'
// Centralized lodash imports - much cleaner!
import {
  map,
  concat,
  sum,
  round,
  every,
  isEmpty,
  filter,
  includes,
  difference,
  sortBy,
  find,
  findIndex,
  get,
  merge,
  cloneDeep,
  zip,
  slice,
  isNil,
  replace,
  head,
  last,
  compact,
  uniq} from '@/utils/lodash'
const Chart = lazy(() => import('@/utils/SafeApexChart'))

import {
  Grid, Box, Button, Card, CardActions, CardContent, CardHeader, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormGroup, FormControlLabel,  List, ListItem, ListItemButton, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, Drawer, IconButton, FormControl, Collapse, Select } from '@mui/material'

import dark365Square from '@/assets/images/365_square_Dark.png'

import ContactAgent from '../../../Marketplace/ContactAgent'

import { UPDATE_PROPERTY } from '@/housefolios-components/PropertyContainer/mutations'
import { GET_PROPERTY } from '@/housefolios-components/PropertyContainer/queries'

import { useMutation } from '@apollo/client/react'
import { UPDATE_ORGANIZATION } from '@/housefolios-components/OrganizationSettings/mutations'
import { DEFAULT_PREFERENCES } from '@/housefolios-components/OrganizationSettings/OrganizationPreferences'
import { Close } from '@mui/icons-material'
import withSession from '@/housefolios-components/Session/withSession'
import { GET_ME } from '@/housefolios-components/Session/queries'
import { enqueueSnackbar } from 'notistack'
import { GET_CARDS } from '@/housefolios-components/Properties/queries'

import { assumptionsOptions } from '@/housefolios-components/AssumptionsSettings/Accordion' //SPECIFIC COMMENT: Don't remove. Used for rehab card fields
import { DEFAULT_ANALYTICS } from '@/housefolios-components/Property/fragments'
import { useLocation } from 'react-router'
import useAmortizationDialog from '@/hooks/useAmortizationDialog'
import AmortizationDialog from '@/housefolios-components/Dialogs/Amortization'
import { loanBalance } from '@/utils/loanBalance'

import {
  ContactInformation,
  getCashEntryFee,
  getCreativeEntryFee,
  getPitiTotal} from '@/utils/loanBalance'
import SubtoPITICash from '@/housefolios-components/Dialogs/SubtoPITI/Cash/'
import SubtoPITICreative from '@/housefolios-components/Dialogs/SubtoPITI/Creative/'
import CommentsDialog from '@/housefolios-components/Dialogs/Comments'
import { RehabCalcInputField } from '@/utils/rehabCalc'
import {
  BRRRRAcquisitionExpensesTour,
  BRRRRBridgeLoanTour,
  BRRRRCashPositioningTour,
  BRRRRComparablePropertiesTour,
  BRRRRDispositionExpensesTour,
  BRRRRGrossMonthlyIncomeTour,
  BRRRRMonthlyCashflowTour,
  BRRRRMonthlyExpensesTour,
  BRRRRRefinanceLoanTour,
  BRRRRRehabExpensesTour,
  BRRRRStrategyTour,
  BRRRRTargetsTour,
  BRRRRValueOverTimeTour} from './tours'

import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'
import {
  ComparablePropertiesCard,
  DeactiveCard,
  StrategyCard,
  StrategyPageBase,
  TargetsCard,
  calculateCompData,
  createChartColors,
  createCurrencyFormat,
  createCashflowChartOptions,
  createDonutChartOptions,
  createPercentageFormat,
  createStrategySummary,
  useStrategyPage} from '../Common'

function CenterPageBRRRR(props) {
  const {
    property,
    analysisInput,
    assumptionsInput,
    renderInputFields} = props

  const {
    openAmortization,
    handleOpenAmortization,
    handleCloseAmortization} = useAmortizationDialog()

  const {
    modal1,
    maxOfferDescription,
    openStrategyTour,
    openTargetsTour,
    openComparablePropertiesTour,
    toggle1,
    toggle1Close,
    toggleMaxOffer,
    toggleStrategyTour,
    toggleTargetsTour,
    toggleComparablePropertiesTour,
    closeStrategyTour,
    closeTargetsTour,
    closeComparablePropertiesTour} = useStrategyPage({ strategyName: 'BRRRR'  })
  const [
    openBRRRRMonthlyCashflowTour,
    setOpenBRRRRMonthlyCashflowTour,
  ] = useState(false)
  const [
    openBRRRRAcquisitionExpensesTour,
    setOpenBRRRRAcquisitionExpensesTour,
  ] = useState(false)
  const [
    openBRRRRGrossMonthlyIncomeTour,
    setOpenBRRRRGrossMonthlyIncomeTour,
  ] = useState(false)
  const [
    openBRRRRMonthlyExpensesTour,
    setOpenBRRRRMonthlyExpensesTour,
  ] = useState(false)
  const [openBRRRRRehabExpensesTour, setOpenBRRRRRehabExpensesTour] =
    useState(false)
  const [openBRRRRBridgeLoanTour, setOpenBRRRRBridgeLoanTour] =
    useState(false)
  const [openBRRRRRefinanceLoanTour, setOpenBRRRRRefinanceLoanTour] =
    useState(false)
  const [openBRRRRValueOverTimeTour, setOpenBRRRRValueOverTimeTour] =
    useState(false)
  const [
    openBRRRRCashPositioningTour,
    setOpenBRRRRCashPositioningTour,
  ] = useState(false)
  const [
    openBRRRRDispositionExpensesTour,
    setOpenBRRRRDispositionExpensesTour,
  ] = useState(false)

  let results = useQuery(GET_CARDS, {
    variables: { view: 'BRRRR' }})
  let data = results.data || {}
  const cardsLoading = results.loading
  const cardsError = results.error
  let { cards = [] } = data

  // const { activeOrg = {} } = props.session.me || {}
  const activeOrg = property?.portfolio?.organization
  const { acquisition = {}, assumptions = {} } = property
  const { analytics = DEFAULT_ANALYTICS, analysis = {} } = acquisition

  const [activeTab, setActiveTab] = useState('0')

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  let amortizationData = loanBalance({
    financeAmount: analytics.BRRRR.refinanceLoanAmount,
    netOperatingIncome: analytics.BRRRR.netOperatingIncomeBRRRR,
    mortgagePayment: analytics.BRRRR.refinanceMortgage,
    monthlyRate: assumptions.refinanceRate / 100 / 12,
    holdingPeriod: assumptions.rentalHoldingPeriodBRRRR * 12,
    payDownAccelerator: assumptions.payDownAccelerator,
    payDownGrowth: assumptions.payDownGrowth,
    growthRateIncome: assumptions.growthRateIncome,
    growthRateExpense: assumptions.growthRateIncome,
  })

  // const [openAmortization, setOpenAmortization] = useState(false)
  // const handleOpenAmortization = () => {
  //   setOpenAmortization(true)
  // }
  // const handleCloseAmortization = () => {
  //   setOpenAmortization(false)
  // }

  const tableHeaders = [
    { title: '', name: 'Date', align: 'left' },
    { title: '', name: 'Interest', align: 'center' },
    { title: '', name: 'Principal', align: 'center' },
    { title: '', name: 'Additional Principal', align: 'center' },
    { title: '', name: 'Balance', align: 'center' },
  ]

  const dollarPercentAmount = (ofAmount, value, peramt) => {
    let typeData = []
    let dollarAmount = 0
    let percentAmount = 0

    if (peramt === '%') {
      dollarAmount = (value / 100) * ofAmount
      percentAmount = value
    } else if (peramt === '$') {
      dollarAmount = value
      if (ofAmount !== 0)
        percentAmount = ((value / ofAmount) * 100).toFixed(2)
    }

    typeData.push({
      dollar: dollarAmount,
      percent: percentAmount,
    })

    return typeData
  }

  let IRRDataFirst = {}
  let IRRData = []
  let IRRDataLast = {}

  const IRRTable = (args) => {
    let {
      valueAppreciation, //arv ? arv : sellPrice
      grossAnnualRent,
      annualExpenses,
      mp_monthly,
      rentalHoldingPeriod,
      growthRateIncomeMonthly,
      growthRateExpenseMonthly,
      rehabPeriod,
      totalOutOfPocket,
      homePriceAppreciation,
      listPriceToSalePriceRatio,
      salesCommission,
      salesCommissionType,
      sellingClosingCostDollar,
      loanBalanceAtHoldingPeriod,
      dispositionFee,
      dispositionFeeType} = args

    let cashFlowTotal = 0
    let arrInHoldingPeriodMonthly = grossAnnualRent / 12
    let expensesInHoldingPeriodMonthly = annualExpenses / 12
    let cashFlowInHoldingPeriodMonthly = 0
    let salePrice = 0

    let month
    let year
    let monthYear

    const today = new Date()

    const IRRDate = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      1,
    )

    for (let index = 1; index < rentalHoldingPeriod + 1; index++) {
      if (index > 1) {
        arrInHoldingPeriodMonthly *= 1 + growthRateIncomeMonthly
        expensesInHoldingPeriodMonthly *= 1 + growthRateExpenseMonthly
      }
      let income =
        index > rehabPeriod + 1 ? arrInHoldingPeriodMonthly : 0
      cashFlowInHoldingPeriodMonthly =
        mp_monthly < 0
          ? income - expensesInHoldingPeriodMonthly
          : income - expensesInHoldingPeriodMonthly - mp_monthly
      if (index === 1) {
        month = IRRDate.toLocaleString('default', { month: 'long'  })
        year = IRRDate.getFullYear().toString()
        monthYear = month + ' ' + year
        IRRDataFirst = {
          totalOutOfPocket,
          monthYear}
      } else {
        valueAppreciation *= 1 + homePriceAppreciation / 12 / 100
        IRRDate.setMonth(IRRDate.getMonth() + 1)
        let month = IRRDate.toLocaleString('default', {
          month: 'long'})
        let year = IRRDate.getFullYear().toString()
        monthYear = month + ' ' + year
        if (index < rentalHoldingPeriod) {
          IRRData.push({
            flow: cashFlowInHoldingPeriodMonthly,
            income,
            expenses: expensesInHoldingPeriodMonthly,
            mortgage: mp_monthly,
            monthYear,
            })
        } else if (index === rentalHoldingPeriod) {
          let cashFlowInHoldingPeriod = cashFlowTotal

          salePrice =
            (listPriceToSalePriceRatio / 100) * valueAppreciation
          let salesCommissionTotal =
            salesCommissionType === '$'
              ? salesCommission
              : (salesCommission / 100) * salePrice

          const dispositionFeeIRRDP = dollarPercentAmount(
            salePrice,
            dispositionFee,
            dispositionFeeType,
          )

          const lastMonthCashFlow =
            salePrice -
            loanBalanceAtHoldingPeriod -
            salesCommissionTotal -
            sellingClosingCostDollar -
            dispositionFeeIRRDP[0].dollar +
            cashFlowInHoldingPeriodMonthly

          IRRDataLast = {
            lastMonthCashFlow,
            monthYear}
        }
      }
    }
  }

  IRRTable({
    valueAppreciation: analytics.BRRRR.arvTotalBRRRR
      ? analytics.BRRRR.arvTotalBRRRR
      : analysis.resellPriceBRRRR,
    grossAnnualRent: sum(analytics.grossAnnualRent),
    annualExpenses: analytics.BRRRR.annualExpensesBRRRR,
    mp_monthly: analytics.BRRRR.refinanceMortgage,
    rentalHoldingPeriod: assumptions.rentalHoldingPeriodBRRRR * 12,
    growthRateIncomeMonthly: assumptions.growthRateIncome / 12 / 100,
    growthRateExpenseMonthly:
      assumptions.growthRateExpense / 12 / 100,
    rehabPeriod: assumptions.rehabPeriodBRRRR,
    totalOutOfPocket: analytics.BRRRR.totalOutOfPocketBRRRR,
    homePriceAppreciation: assumptions.homePriceAppreciation,
    listPriceToSalePriceRatio: assumptions.listPriceToSalePriceRatio,
    salesCommission: assumptions.salesCommissionBRRRR,
    salesCommissionType: assumptions.salesCommissionBRRRRType,
    sellingClosingCostDollar:
      analytics.BRRRR.sellingClosingCostDollarBRRRR,
    loanBalanceAtHoldingPeriod:
      analytics.BRRRR.loanBalanceAtHoldingPeriodBRRRR,
    dispositionFee: assumptions.dispositionFeeBRRRR,
    dispositionFeeType: assumptions.dispositionFeeBRRRRType})

  const IRRTableFirstHeaders = [
    { title: '', name: 'Date', align: 'left' },
    { title: '', name: 'Total Out of Pocket', align: 'center' },
  ]

  const IRRTableHeaders = [
    { title: '', name: 'Date', align: 'left' },
    { title: '', name: 'Income', align: 'center' },
    { title: '', name: 'Expenses', align: 'center' },
    { title: '', name: 'Mortgage', align: 'center' },
    { title: '', name: 'Cashflow', align: 'center' },
  ]

  const IRRTableLastHeaders = [
    { title: '', name: 'Date', align: 'left' },
    { title: '', name: 'Last Month Cashflow', align: 'center' },
  ]

  const currencyFormat = createCurrencyFormat()
  const pieColors = createChartColors()

  const currencyFormat2 = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 })

  const percentageFormat = createPercentageFormat()

  // const numberFormat = new Intl.NumberFormat('en-US', {
  //   minimumFractionDigits: 0,
  //   maximumFractionDigits: 0,
  // })

  const [openManagementCompanies, setOpenManagementCompanies] =
    useState(false)
  const handleOpenManagementCompanies = () => {
    setOpenManagementCompanies(true)
  }
  const handleCloseManagementCompanies = () => {
    setOpenManagementCompanies(false)
  }

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked  })
  }

  const [dealSauceView, setDealSauceView] = useState('creative')
  const [openPITICashData, setOpenPITICashData] = useState(false)
  const [openPITICreativeData, setOpenPITICreativeData] =
    useState(false)

  const pitiTotal = getPitiTotal(property)
  const creativeEntryFee = getCreativeEntryFee(property)
  const cashEntryFee = getCashEntryFee(property)

  const [accordion, setAccordion] = useState(-1)

  const toggleAccordion = (index) => {
    if (index === accordion) setAccordion(-1)
    else setAccordion(index)
  }

  const [getFinancing, setGetFinancing] = useState(null)

  const toggleGetFinancing = (name) => {
    setGetFinancing(name)
  }

  const toggleGetFinancingClose = () => {
    setGetFinancing(null)
  }
  const cashFlowAccumulationCalculate = (args) => {
    const {
      accelerator,
      term,
      rentAmount,
      vacancy,
      propertyTaxes,
      homeInsurance,
      monthlyHOA,
      propertyMgmtPercent,
      maintenance,
      utilities,
      annualRevenueIncrease,
      annualOperatingExpenseIncrease,
      //added so that cash flow is with Financing
      mortgagePayment} = args

    let pdAccelerator = accelerator / 100
    let rent = rentAmount
    let rentIncrease = map(rent, (value) => 0)
    let vac = map(
      zip(rentAmount, vacancy),
      ([rentAmount, vacancy]) => rentAmount * vacancy,
    )
    let revenue = 0
    let propTax = propertyTaxes
    let propTaxIncrease = 0
    let insurance = homeInsurance
    let insuranceIncrease = 0
    let hoa = monthlyHOA
    let hoaIncrease = 0
    let propMgmt = sum(rentAmount) * propertyMgmtPercent
    let main = sum(rentAmount) * maintenance
    let mainIncrease = 0
    let uti = utilities
    let utiIncrease = 0
    let expenses = 0
    let cashFlow = 0
    let cfyear = []
    //added so that cash flow is with Financing
    let mortgage = 0

    for (let index = 1; index < term; index++) {
      if (index > 1 && index < 12) {
        rent = map(
          zip(rent, rentAmount),
          ([rent, rentAmount]) => rent + rentAmount,
        )
        propTax += propertyTaxes
        insurance += homeInsurance
        hoa += monthlyHOA
        //added so that cash flow is with Financing
        mortgage += mortgagePayment
      } else if (index % 12 === 0) {
        if (index / 12 === 1) {
          rent = map(
            zip(rent, rentAmount),
            ([rent, rentAmount]) => rent + rentAmount,
          )
          vac = map(
            zip(rent, vacancy),
            ([rent, vacancy]) => rent * vacancy,
          )
          revenue = sum(rent) - sum(vac)

          propTax += propertyTaxes
          insurance += homeInsurance
          hoa += monthlyHOA
          propMgmt = revenue * propertyMgmtPercent
          main = sum(rent) * maintenance
          expenses = propTax + insurance + hoa + propMgmt + main + uti

          //added so that cash flow is with Financing
          mortgage += mortgagePayment

          cashFlow = revenue - expenses - mortgage
          cashFlow = cashFlow - pdAccelerator * cashFlow

          cfyear.push({
            year: index / 12,
            cashFlow: cashFlow})

          rentIncrease = map(
            rentAmount,
            (rentAmount) =>
              rentAmount + rentAmount * annualRevenueIncrease,
          )
          propTaxIncrease =
            propTax * (1 + annualOperatingExpenseIncrease)
          insuranceIncrease =
            insurance * (1 + annualOperatingExpenseIncrease)
          hoaIncrease = hoa * (1 + annualOperatingExpenseIncrease)
          mainIncrease = main * (1 + annualOperatingExpenseIncrease)
          utiIncrease = uti * (1 + annualOperatingExpenseIncrease)
        } else {
          rent = map(
            zip(rent, rentIncrease),
            ([rent, rentIncrease]) => rent + rentIncrease,
          )
          vac = map(
            zip(rent, vacancy),
            ([rent, vacancy]) => rent * vacancy,
          )
          revenue = sum(rent) - sum(vac)

          propTax += propTaxIncrease
          insurance += insuranceIncrease
          hoa += hoaIncrease
          propMgmt = revenue * propertyMgmtPercent
          main += mainIncrease
          uti += utiIncrease
          expenses = propTax + insurance + hoa + propMgmt + main + uti

          //added so that cash flow is with Financing
          mortgage += mortgagePayment

          cashFlow = revenue - expenses - mortgage
          cashFlow = cashFlow - pdAccelerator * cashFlow

          cfyear.push({
            year: index / 12,
            cashFlow: cashFlow})

          rentIncrease = map(
            rentIncrease,
            (rentIncrease) =>
              rentIncrease + rentIncrease * annualRevenueIncrease,
          )
          propTaxIncrease =
            propTaxIncrease * (1 + annualOperatingExpenseIncrease)
          insuranceIncrease =
            insuranceIncrease * (1 + annualOperatingExpenseIncrease)
          hoaIncrease =
            hoaIncrease * (1 + annualOperatingExpenseIncrease)
          mainIncrease =
            mainIncrease * (1 + annualOperatingExpenseIncrease)
          utiIncrease =
            utiIncrease * (1 + annualOperatingExpenseIncrease)
        }
      } else {
        rent = map(
          zip(rent, rentIncrease),
          ([rent, rentIncrease]) => rent + rentIncrease,
        )
        //added so that cash flow is with Financing
        mortgage += mortgagePayment
      }
    }

    return cfyear
  }

  const cashFlowAccumulation = cashFlowAccumulationCalculate({
    accelerator: assumptions.payDownAccelerator || 0,
    term:
      assumptions.termBRRRRType === 'Years'
        ? (assumptions.termBRRRR || 0) * 12 + 1
        : (assumptions.termBRRRR || 0) + 1,
    rentAmount: analysis.rent || [0],
    vacancy: assumptions.vacancy
      ? map(assumptions.vacancy, (vacancy) => vacancy / 100)
      : [0],
    propertyTaxes: (analysis.propertyTaxes || 0) / 12,
    homeInsurance:
      (analytics.BRRRR.refinancePropertyInsuranceDollar || 0) / 12,
    monthlyHOA: analytics.BRRRR.hoaTotal / 12 || 0,
    propertyMgmtPercent:
      (assumptions.propertyManagementBRRRR || 0) / 100,
    maintenance: (assumptions.maintenanceBRRRR || 0) / 100,
    utilities: analytics.BRRRR.utilitiesTypeDollarBRRRR || 0,
    annualRevenueIncrease: (assumptions.growthRateIncome || 0) / 100,
    annualOperatingExpenseIncrease:
      (assumptions.growthRateExpense || 0) / 100,
    mortgagePayment: analytics.BRRRR.refinanceMortgage || 0})

  let cashFlow1 = 0
  let cashFlow3 = 0
  let cashFlow5 = 0
  let cashFlow10 = 0

  for (let key in cashFlowAccumulation) {
    const tmp = cashFlowAccumulation[key]
    if (tmp.year === 1) cashFlow1 = tmp.cashFlow
    if (tmp.year === 3) cashFlow3 = tmp.cashFlow
    if (tmp.year === 5) cashFlow5 = tmp.cashFlow
    if (tmp.year === 10) cashFlow10 = tmp.cashFlow
  }

  const options = {
    dataLabels: {
      enabled: false},
    xaxis: {
      categories: ['1 yr', '3 yrs', '5 yrs', '10 yrs']},
    yaxis: {
      labels: {
        formatter: currencyFormat.format}},
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w  }) {
        return (
          '<div class="arrow_box">' +
          '<span>' +
          //[w.globals.labels][dataPointIndex] +
          ['1 yr', '3 yrs', '5 yrs', '10 yrs'][dataPointIndex] +
          ': ' +
          currencyFormat.format(series[seriesIndex][dataPointIndex]) +
          '</span>' +
          '</div>'
        )
      }}}
  const series = [
    {
      data: [
        round(cashFlow1) || 0,
        round(cashFlow3) || 0,
        round(cashFlow5) || 0,
        round(cashFlow10) || 0,
      ],
    },
  ]

  const basicAcquisitionFields = [
    {
      type: 'dollar',
      name: 'offerPrice',
      label: 'Purchase Price',
      value:
        analysisInput.offerPrice === null
          ? //? analysisInput.listPrice.toString()
            ''
          : analysisInput.offerPrice.toString(),
      helper:
        !analysisInput.offerPrice || analysisInput.offerPrice === '0'
          ? '0% Discount to Price'
          : (
              (1 -
                analysisInput.offerPrice / analysisInput.listPrice) *
              100
            ).toFixed(0) + '% Discount to Price',
      // xs: 6,
      xs: 12,
      lg: 6,
      definition: 'offerPrice',
      tooltipField:
        'The price that has been agreed upon by the owner and buyer for the transferring of a property.',
      tooltipButtonText: 'Show Purchase Price data',
      dataTour: 'acquisitionExpenses-step-3'},
    {
      type: 'dollar',
      name: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? 'afterRepairValueBRRRR'
        : 'afterRepairValue',
      label: 'After Repair Value',
      tooltipButtonText: 'Show ARV data',
      value: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? analysisInput.afterRepairValueBRRRR === null
          ? ''
          : analysisInput.afterRepairValueBRRRR.toString()
        : analysisInput.afterRepairValue === null
          ? ''
          : analysisInput.afterRepairValue.toString(),
      //helper: currencyFormat.format(analytics.buyHold.equity) + ' in equity',
      // xs: 6,
      xs: 12,
      lg: 6,
      definition: 'afterRepairValue',
      definitionTarget: includes(
        assumptionsInput.strategySpecificFields,
        'afterRepairValue',
      )
        ? 'afterRepairValueBRRRR'
        : 'afterRepairValue',
      tooltipField:
        'The ARV is the value of a property after you have conducted repairs and are ready to sell.',
      dataTour: 'acquisitionExpenses-step-4'},
    {
      type: 'dropdown',
      name: 'closingCostBRRRR',
      value: assumptionsInput.closingCostBRRRR,
      label: 'Closing Cost',
      adornmentToggle: assumptionsInput.closingCostBRRRRType,
      adornment: assumptionsInput.closingCostBRRRRType,
      adornmentName: 'closingCostBRRRRType',
      // xs: 6,
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Fees (attorney/title fees, etc) Paid at Closing. Expressed as a dollar amount or precentage of the purchase prices.',
      dataTour: 'acquisitionExpenses-step-5'},
    {
      type: 'dollar',
      name: 'creditFromSeller',
      value: assumptionsInput.creditFromSeller,
      label: 'Credit From Seller',
      // xs: 6,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A seller credit is the dollar amount the seller will put towards your closing costs.',
      dataTour: 'acquisitionExpenses-step-6'},
  ]

  const advancedAcquisitionFields = [
    {
      type: 'dropdown',
      name: 'acquisitionCommission',
      label: 'Acq Commission',
      value: assumptionsInput.acquisitionCommission,
      adornmentToggle: assumptionsInput.acquisitionCommissionType,
      adornment: assumptionsInput.acquisitionCommissionType,
      adornmentName: 'acquisitionCommissionType',
      // xs: 6,
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Advanced Fee - Used in addition to sales of typical sales commissions expressed as a percentage of the Purchase price or a fixed dollar amount.'},
    {
      type: 'dollar',
      name: 'acquisitionFee',
      label: 'Acquisition Fee',
      value: assumptionsInput.acquisitionFee,
      // xs: 6,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Advanced Fee - Used in addition to sales of typical sales commissions expressed as a fixed dollar amount'},
    // {
    //   type: 'percentage',
    //   name: 'assetManagementFee',
    //   label: 'Asset Mgmt Fee',
    //   value: assumptionsInput.assetManagementFee,
    //   xs: 6,
    //   assumptions: true,
    // },
    {
      type: 'dropdown',
      name: 'financingFeeBRRRR',
      label: 'Financing Fee',
      value: assumptionsInput.financingFeeBRRRR,
      adornment: assumptionsInput.financingFeeBRRRRType,
      adornmentToggle: assumptionsInput.financingFeeBRRRRType,
      adornmentName: 'financingFeeBRRRRType',
      // xs: 6,
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Advanced Fee - A fee that the real estate professional charges for securing financing on the property. Expressed as a percentage of the loan amount.'},
    {
      type: 'dollar',
      name: 'ownerReservesBRRRR',
      label: '1x Owner Reserve',
      value: assumptionsInput.ownerReservesBRRRR,
      // xs: 6,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A one-time reserve you set aside (ex: $5,000) to cover unforeseen repairs, etc. This amount is in addition to the monthly capex (reserve) you set aside each month.'},
  ]

  const customAcquisitonField = [
    {
      type: 'budgetLines',
      name: 'customAcquisitionExpenses',
      value: analysisInput.customAcquisitionExpenses,
      label: 'Custom Acquisition Expenses',
      options: activeOrg.customAcquisitionExpenseTypes,
      xs: 12,
      optionName: 'customAcquisitionExpenseTypes',
      removeOption: true},
  ]

  const propertyManagementCompanies = [
    {
      image:
        'https://assets-global.website-files.com/5ebdcacf6fe55d6b95c4f2a1/5f244161238395a76fe1c352_logo-dark-vertical.svg',
      name: 'Mynd',
      // link: 'https://www.mynd.co/partners/housefolios',
      link: 'https://www.mynd.co',
      value: 'mynd'},
    {
      image: dark365Square,
      name: 'home365',
      link: 'https://www.home365.co',
      value: 'home365'},
    {
      image: '/images/guardianAsset.jpeg',
      name: 'Guardian Asset',
      link: 'https://guardianassetmgt.com/Home/Contact',
      value: 'guardianAsset'},
  ]

  const uncheckAdvanced = every(
    advancedAcquisitionFields,
    (field) => !field.value,
  )

  const [state, setState] = React.useState({
    checkedA: !uncheckAdvanced,
    checkedB: false,
    checkedF: false,
    checkedG: false })

  const acquisitionChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      [
        'Purchase Price',
        'Bridge Closing Costs',
        'Acquisition Commission',
        'Acquisition Fee',
        /*'Asset Mangement Fee',*/ 'Points',
        'Financing Fee',
        'One-time Owner Reserve',
      ],
      map(
        analysis.customAcquisitionExpenses,
        (expense) => expense.value,
      ),
    ),
    pieColors,
  )
  const acquisitionChartSeries = concat(
    [
      round(
        analysis.offerPrice === null
          ? analysis.listPrice
          : analysis.offerPrice,
        2,
      ) || 0.0001,
      round(analytics.BRRRR.closeCostDollarBridge, 2) || 0,
      round(analytics.acquisitionCommissionDollar, 2) || 0,
      round(assumptions.acquisitionFee, 2) || 0,
      /*round(analytics.BRRRR.assetManagementFeeTotalBRRRR, 2) || 0,*/ round(
        analytics.BRRRR.bridgePointsAmount +
          analytics.BRRRR.refinancePointsAmount,
        2,
      ) || 0,
      round(analytics.BRRRR.refinancingFeeTotal, 2) || 0,
      round(assumptions.ownerReservesBRRRR, 2) || 0,
    ],
    map(
      analysis.customAcquisitionExpenses,
      (expense) => round(expense.value, 2) || 0,
    ),
  )

  const grossMonthlyIncomeFields = filter(
    [
      {
        type: 'select',
        name: 'rentType',
        label: 'Rent Type',
        value: assumptionsInput.rentType,
        options: assumptionsOptions(activeOrg)?.rentTypes,
        xs: 12,
        lg: 12,
        assumptions: true},
      {
        type: 'dollar',
        name: `rent.${props.activeUnit}`,
        label: 'Total Rental Income',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rent[props.activeUnit] === null
            ? ''
            : analysisInput.rent[props.activeUnit].toString(),
        helper:
          property.sqft &&
          property.sqft[props.activeUnit] &&
          analysisInput.rent[props.activeUnit]
            ? currencyFormat2.format(
                analysisInput.rent[props.activeUnit] /
                  property.sqft[props.activeUnit],
              ) + ' rent per sqft'
            : '$0.00 rent per sqft',
        xs: 12,
        lg: 6,
        definition: 'rent',
        // disabled: !isNil(analysisInput.ownerOccupiedBRRRR) && props.activeUnit === analysisInput.ownerOccupiedBRRRR,
        tooltipField:
          "A tenant's monthly payment to a landlord for the use of property or land.",
        hide: assumptionsInput.rentType !== 'singleRent',
        dataTour: 'grossMonthlyIncome-step-1'},
      {
        type: 'dollar',
        name: `rentLow.${props.activeUnit}`,
        label: 'Rent Range Low',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rentLow[props.activeUnit] === null
            ? ''
            : analysisInput.rentLow[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        definition: 'rent',
        tooltipField: 'Lower end of projected rent',
        hide: assumptionsInput.rentType !== 'rentRange',
        dataTour: ''},
      {
        type: 'dollar',
        name: `rentHigh.${props.activeUnit}`,
        label: 'Rent Range High',
        tooltipButtonText: 'Show Total Rent data',
        value:
          analysisInput.rentHigh[props.activeUnit] === null
            ? ''
            : analysisInput.rentHigh[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        definition: 'rent',
        tooltipField: 'Higher end of projected rent',
        hide: assumptionsInput.rentType !== 'rentRange',
        dataTour: ''},
      {
        type: 'percentage',
        name: `vacancy.${props.activeUnit}`,
        label: 'Vacancy Rate',
        value: assumptionsInput.vacancy[props.activeUnit],
        xs: 12,
        lg: 6,
        assumptions: true,
        tooltipField:
          'The percentage of time that a property is not rented out during the course of a year.',
        dataTour: 'grossMonthlyIncome-step-2'},
      {
        type: 'dollar',
        name: `otherIncome.${props.activeUnit}`,
        label: 'Other Monthly Income',
        value:
          analysisInput.otherIncome[props.activeUnit] === null
            ? ''
            : analysisInput.otherIncome[props.activeUnit].toString(),
        xs: 12,
        lg: 6,
        tooltipField:
          'Additional income you earn through the property. Some examples might be coin-op laundry, parking, storage, etc.',
        dataTour: 'grossMonthlyIncome-step-3'},
    ],
    (field) => !field.hide,
  )

  const grossMonthlyIncomeChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      map(
        analytics.grossAnnualRent,
        (value, index) => `Unit ${index + 1} Monthly Rental Income`,
      ),
      map(
        analysis.otherIncome,
        (value, index) => `Unit ${index + 1} Other Monthly Income`,
      ),
    ),
    pieColors,
  )
  const grossMonthlyIncomeChartSeries = concat(
    map(
      analytics.grossAnnualRent,
      (grossAnnualRent, index) =>
        round(grossAnnualRent / 12, 2) || (index === 0 ? 0.0001 : 0),
    ),
    map(
      analysis.otherIncome,
      (otherIncome) => round(otherIncome, 2) || 0,
    ),
  )

  const expenseCard =
    find(
      cards,
      (card) =>
        card.name === 'expenses' && card.member === activeOrg.member,
    ) ||
    find(
      cards,
      (card) => card.name === 'expenses' && card.member === null,
    ) ||
    {}
  const monthlyExpensesFields = map(
    get(expenseCard, 'card.fields'),
    (field) => {
      const input = field.analytics
        ? analytics.BRRRR
        : field.assumptions
          ? assumptionsInput
          : analysisInput
      const name =
        field.name === 'mortgage'
          ? 'refinanceMortgage'
          : field.suffix
            ? includes(field.name, 'Type')
              ? replace(field.name, 'Type', 'BRRRRType')
              : field.name + 'BRRRR'
            : field.name
      const adornmentName =
        field.suffix && field.adornmentName
          ? includes(field.adornmentName, 'Type')
            ? replace(field.adornmentName, 'Type', 'BRRRRType')
            : field.adornmentName + 'BRRRR'
          : field.adornmentName
      const definition =
        field.suffix && field.definition
          ? includes(field.definition, 'Type')
            ? replace(field.definition, 'Type', 'BRRRRType')
            : field.definition + 'BRRRR'
          : field.definition
      const options =
        field.options && field.assumptions
          ? get(assumptionsOptions(activeOrg), field.options) ||
            get(activeOrg, field.options) ||
            field.options
          : get(activeOrg, field.options) || field.options
      return {
        ...field,
        name,
        value: get(input, name),
        adornmentToggle: get(input, adornmentName),
        adornment: get(input, adornmentName),
        adornmentName: adornmentName,
        definition: definition,
        options: options}
    },
  )

  const monthlyExpensesChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      [
        'Property Insurance',
        'Property Mgmt Fee',
        'Monthly HOA',
        'Property Taxes',
        'Maintenance',
        'Utilities',
        'Capex',
        'Other Expenses',
        'Mortgage',
      ],
      map(analysis.customMonthlyExpenses, (expense) => expense.type),
    ),
    pieColors,
  )
  const monthlyExpensesChartSeries = concat(
    [
      round(
        analytics.BRRRR.refinancePropertyInsuranceDollar / 12,
        2,
      ) || 0.0001,
      round(analytics.BRRRR.propertyManagementDollarBRRRR / 12, 2) ||
        0,
      round(analytics.BRRRR.hoaTotal / 12, 2) || 0,
      round(analysis.propertyTaxes / 12, 2) || 0,
      round(analytics.BRRRR.maintenanceBRRRRDollar / 12, 2) || 0,
      round(analytics.BRRRR.utilitiesTypeDollarBRRRR, 2) || 0,
      round(analytics.BRRRR.monthlyReservesTypeDollarBRRRR, 2) || 0,
      round(assumptions.otherExpenseBRRRR / 12, 2) || 0,
      round(analytics.BRRRR.refinanceMortgage, 2) || 0,
    ],
    map(
      analysis.customMonthlyExpenses,
      (expense) => round(expense.value, 2) || 0,
    ),
  )

  // const rehabCard =
  //   find(
  //     cards,
  //     (card) =>
  //       card.name === 'rehab' && card.member === activeOrg.member,
  //   ) ||
  //   find(
  //     cards,
  //     (card) => card.name === 'rehab' && card.member === null,
  //   ) ||
  //   {}
  // const rehabFields = filter(
  //   map(get(rehabCard, 'card.fields'), (field) => {
  //     const input = field.analytics
  //       ? analytics.BRRRR
  //       : field.assumptions
  //       ? assumptionsInput
  //       : analysisInput
  //     const options =
  //       field.options && field.assumptions
  //         ? get(assumptionsOptions(activeOrg), field.options) ||
  //           get(activeOrg, field.options) ||
  //           field.options
  //         : get(activeOrg, field.options) || field.options
  //     const memberOptions =
  //       field.memberOptions && field.assumptions
  //         ? get(assumptionsOptions(activeOrg), field.memberOptions) ||
  //           get(activeOrg, field.memberOptions)
  //         : get(activeOrg, field.memberOptions)
  //     const name = field.suffix
  //       ? includes(field.name, 'Type')
  //         ? replace(field.name, 'Type', 'BRRRRType')
  //         : field.name + 'BRRRR'
  //       : field.name
  //     const hide =
  //       field.suffix && field.hide
  //         ? includes(field.hide, 'Type')
  //           ? replace(field.hide, 'Type', 'BRRRRType')
  //           : field.hide + 'BRRRR'
  //         : field.hide
  //     const adornmentName =
  //       field.suffix && field.adornmentName
  //         ? includes(field.adornmentName, 'Type')
  //           ? replace(field.adornmentName, 'Type', 'BRRRRType')
  //           : field.adornmentName + 'BRRRR'
  //         : field.adornmentName
  //     const definition =
  //       field.suffix && field.definition
  //         ? includes(field.definition, 'Type')
  //           ? replace(field.definition, 'Type', 'BRRRRType')
  //           : field.definition + 'BRRRR'
  //         : field.definition
  //     const helper = includes(field.name, 'rehabTier')
  //       ? currencyFormat.format(
  //           (field.value ? eval(field.value) : get(input, name)) *
  //             (assumptionsInput.percentageOfARVFixFlip / 100) *
  //             propertyInput.sqft,
  //         ) + ' Total'
  //       : null
  //     return {
  //       ...field,
  //       name,
  //       value: get(input, name),
  //       adornmentToggle: get(input, adornmentName),
  //       adornment: get(input, adornmentName),
  //       adornmentName: adornmentName,
  //       definition: definition,
  //       options: filter(
  //         options,
  //         (option) =>
  //           isEmpty(option.showMarkets) ||
  //           includes(option.showMarkets, analysisInput.marketType),
  //       ),
  //       memberOptions: filter(
  //         memberOptions,
  //         (option) =>
  //           isEmpty(option.showMarkets) ||
  //           includes(option.showMarkets, analysisInput.marketType),
  //       ),
  //       helper,
  //       hide,
  //     }
  //   }),
  //   (field) => !field.hide || !eval(field.hide),
  // )
  const rehabFields = filter(
    [
      {
        type: 'select',
        name: 'rehabBRRRRType',
        label: 'Rehab Type',
        value: assumptionsInput.rehabBRRRRType,
        xs: 12,
        options: assumptionsOptions(activeOrg)?.rehabOptions,
        suffix: true,
        assumptions: true},
      {
        type: 'dollar',
        name: 'rehabCostBRRRR',
        label: 'Est Rehab',
        value: analysisInput.rehabCostBRRRR,
        tooltipButtonText: 'Show Estimated Rehab data',
        xs: 12,
        lg: 6,
        definition: 'rehabCostBRRRR',
        tooltipField:
          'An expense that is incurred when restoring an entity to its normal or near-normal condition.',
        hide: assumptionsInput.rehabBRRRRType !== 'singleRehabValue',
        dataTour: 'rehabExpenses-step-1'},
      {
        type: 'budgetLines',
        name: 'detailedRehabCostBRRRR',
        label: 'Rehab Costs',
        value: analysisInput.detailedRehabCostBRRRR,
        xs: 12,
        options: [
          'Appliances',
          'Cabinets/Vanities',
          'Carpet',
          'Countertops/Sinks/Toilets',
          'Driveway/Decking/Patio',
          'Electrical',
          'Exterior',
          'Flooring',
          'Framing',
          'Insulation/Drywall',
          'Landscaping',
          'Masonry',
          'Mechanical',
          'Molding/Tile/Trim',
          'Paint',
          'Plans/Permits',
          'Plumbing',
          'Roof',
          'Siding/Gutters',
          'Site Prep',
          'Staging',
          'Windows/Doors',
          'Other',
        ],
        hide: assumptionsInput.rehabBRRRRType !== 'detailedRehab',
        dataTour: 'rehabExpenses-step-1'},
      {
        type: 'rehabCalc',
        name: 'rehabCalcTotalBRRRR',
        label: 'Rehab Calculator',
        value: analysisInput.rehabCalcTotalBRRRR,
        xs: 12,
        lg: 6,
        property: property,
        assumptionsInput: assumptionsInput,
        affiliate: props.affiliate,
        hide: assumptionsInput.rehabBRRRRType !== 'rehabCalc',
        dataTour: 'rehabExpenses-step-1'},
      {
        type: 'select',
        name: 'rehabTierBRRRR',
        label: 'Rehab Tier',
        value: assumptionsInput.rehabTierBRRRR,
        tooltipButtonText: 'Show Estimated Rehab data',
        xs: 12,
        lg: 6,
        options: filter(
          activeOrg.rehabTiers,
          (option) =>
            isEmpty(option.showMarkets) ||
            includes(
              option.showMarkets,
              analysisInput.marketType ||
                props.affiliate?.defaultMarketType,
            ),
        ),
        optionName: 'rehabTiers',
        memberOptions: filter(
          activeOrg.memberRehabTiers,
          (option) =>
            isEmpty(option.showMarkets) ||
            includes(
              option.showMarkets,
              analysisInput.marketType ||
                props.affiliate?.defaultMarketType,
            ),
        ),
        dynamicMemberOptions: map(
          filter(
            activeOrg.dynamicMemberRehabTiers,
            (option) =>
              isEmpty(option.showMarkets) ||
              includes(
                option.showMarkets,
                analysisInput.marketType ||
                  props.affiliate?.defaultMarketType,
              ),
          ),
          (option) => {
            let breakPointIndex = 0
            const arv = includes(
              assumptionsInput.strategySpecificFields,
              'afterRepairValue',
            )
              ? analysisInput.afterRepairValueBRRRR === null
                ? null
                : analysisInput.afterRepairValueBRRRR
              : analysisInput.afterRepairValue === null
                ? null
                : analysisInput.afterRepairValue
            while (
              option?.breakpoints[breakPointIndex] < arv &&
              breakPointIndex < option?.breakpoints.length
            ) {
              breakPointIndex++
            }
            return {
              ...option,
              label: `$${option.values[breakPointIndex]}/Sqft`}
          },
        ),
        removeOption: true,
        assumptions: true,
        hide:
          assumptionsInput.rehabBRRRRType !== 'rehabTier' &&
          assumptionsInput.rehabBRRRRType !== 'flippingAmericaRehab',
        dataTour: 'rehabExpenses-step-1',
        helper: currencyFormat.format(
          analytics.BRRRR.rehabTierValueBRRRR,
        )},
      {
        name: 'marketType',
        value: !analysisInput.marketType
          ? props.affiliate?.defaultMarketType
          : analysisInput.marketType,
        label: 'Market Type',
        options: concat(
          [props.affiliate?.defaultMarketType],
          props.affiliate?.marketTypes,
        ),
        type: 'select',
        xs: 12,
        lg: 6,
        hide:
          isEmpty(props.affiliate?.marketTypes) ||
          (assumptionsInput.rehabBRRRRType !== 'rehabTier' &&
            assumptionsInput.rehabBRRRRType !==
              'flippingAmericaRehab')},
      {
        type: 'dollar',
        name: 'rehabDecadeCostBRRRR',
        value: assumptionsInput.rehabDecadeCostBRRRR,
        label: 'Rehab Per Decade',
        xs: 12,
        lg: 6,
        assumptions: true,
        hide:
          assumptionsInput.rehabBRRRRType !== 'flippingAmericaRehab'},
      {
        type: 'number',
        name: 'rehabPeriodBRRRR',
        value: assumptionsOptions(activeOrg)?.rehabPeriodBRRRR,
        label: 'Rehab Period (mo)',
        xs: 12,
        lg: 6,
        tooltipField:
          'AnA holding period is the amount of time the investment is held by an investor or the period between the purchase and sale of the property. Expressed in months.',
        assumptions: true},
      {
        type: 'dollar',
        name: 'bridgeRehabHoldingCost',
        value: analytics.BRRRR.bridgeRehabHoldingCost,
        label: 'Holding Cost',
        xs: 12,
        lg: 6,
        disabled: true,
        analytics: true,
        tooltipField:
          'The cost of the bridge loan during your rehab period',
        dataTour: 'rehabExpenses-step-2'},
      {
        type: 'dropdown',
        name: 'rehabContingencyBRRRR',
        value: assumptionsInput.rehabContingencyBRRRR,
        adornment: assumptionsInput.rehabContingencyBRRRRType,
        adornmentToggle: assumptionsInput.rehabContingencyBRRRRType,
        adornmentName: 'rehabContingencyBRRRRType',
        label: 'Rehab Contingency',
        xs: 12,
        lg: 6,
        tooltipField:
          'Percentage of calculated rehab cost added as a saftey margin',
        assumptions: true,
        dropdown: true,
        helper:
          assumptionsInput.rehabContingencyBRRRRType === '%'
            ? currencyFormat.format(
                (analytics.BRRRR.corTotalBRRRR *
                  assumptionsInput.rehabContingencyBRRRR) /
                  100,
              )
            : null},
    ],
    (field) => !field.hide,
  )

  const rehabChartOptions = createDonutChartOptions(
    currencyFormat,
    concat(
      assumptionsInput.rehabBRRRRType === 'detailedRehab'
        ? isEmpty(analysis.detailedRehabCostBRRRR)
          ? ['Total Rehab']
          : map(
              analysis.detailedRehabCostBRRRR,
              (line) => line.type || 'Unlabeled',
            )
        : ['Total Rehab'],
      ['Holding Costs During Bridge Loan'],
    ),
    pieColors,
  )
  const rehabChartSeries = concat(
    assumptionsInput.rehabBRRRRType === 'detailedRehab'
      ? isEmpty(analysis.detailedRehabCostBRRRR)
        ? [0.0001]
        : map(analysis.detailedRehabCostBRRRR, (line, index) =>
            index === 0
              ? round(line.value, 2) || 0.0001
              : round(line.value, 2) || 0,
          )
      : [round(analytics.BRRRR.corTotalBRRRR, 2) || 0.0001],
    [
      round(
        analytics.BRRRR.holdingExpensesBridge *
          (assumptions.bridgeTermType === 'Years'
            ? assumptions.bridgeTerm * 12
            : assumptions.bridgeTerm),
        2,
      ) || 0,
    ],
  )

  const financingFields = [
    {
      type: 'checkbox',
      label: 'Cash Purchase',
      name: 'bridgeCashPurchase',
      value: assumptionsInput.bridgeCashPurchase,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Investor pays 100% of the purchase price in cash and does not have a mortgage payment.',
      dataTour: 'bridgeLoan-step-1'},
    {
      type: 'percentage',
      name: 'bridgeDownPayment',
      label: 'Down Payment',
      value: assumptionsInput.bridgeDownPayment || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The amount of cash that a purchaser must put down, toward the purchase price, to buy real estate. The down payment amount is a percentage of the total purchase price, dictated by the lender.',
      dataTour: 'bridgeLoan-step-2'},
    {
      type: 'percentage',
      name: 'financingRepairsPercentageBRRRR',
      label: '% of Rehab',
      value: analysisInput.financingRepairsPercentageBRRRR || 0,
      xs: 12,
      lg: 6,
      tooltipField:
        'The percentage of the repair cost that is being covered by the loan',
      dataTour: 'bridgeLoan-step-7'},
    {
      type: 'percentage',
      name: 'bridgeRate',
      label: 'Interest Rate',
      value: assumptionsInput.bridgeRate || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The interest rate is the amount a lender charges for the use of capital, expressed as a percentage of the principal. The interest rate is typically noted on an annual basis known as the annual percentage rate (APR).',
      dataTour: 'bridgeLoan-step-3'},
    {
      type: 'dropdown',
      name: 'bridgeTerm',
      label: 'Financing Term',
      value: assumptionsInput.bridgeTerm || 0,
      adornment: assumptionsInput.bridgeTermType,
      adornmentToggle: assumptionsInput.bridgeTermType,
      adornmentName: 'bridgeTermType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'The length of time that the loan is being amortized. Expressed in months or years.',
      dataTour: 'bridgeLoan-step-4'},
    {
      type: 'number',
      name: 'bridgePoints',
      label: 'Points',
      value: assumptionsInput.bridgePoints || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Often when you take out a loan, you will pay "points" (aka: fees) on the loan. It is essentially prepaid interest charged by the lender. One point is equal to 1% of the loan amount. For example, a $100,000 loan with 2 points would be $2,000.',
      dataTour: 'bridgeLoan-step-5'},
    {
      type: 'checkbox',
      name: 'bridgeInterestOnlyLoan',
      label: 'Interest Only Loan',
      value: assumptionsInput.bridgeInterestOnlyLoan,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A loan that only requires the payment of interest, not principal.',
      dataTour: 'bridgeLoan-step-6'},
    // {
    //   type: 'checkbox',
    //   name: 'financingRepairsBRRRR',
    //   label: 'Finance Repairs',
    //   value: analysisInput.financingRepairsBRRRR || false,
    //   xs: 12,
    //   lg: 6,
    //   tooltipField: 'Your down payment adjusts what percentage of your repairs will be financed.',
    //   dataTour: "bridgeLoan-step-7",
    // },
  ]

  const refinancingFields = [
    {
      type: 'checkbox',
      label: 'Cash Purchase',
      name: 'refinanceCashPurchase',
      value: assumptionsInput.refinanceCashPurchase,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Investor pays 100% of the purchase price in cash and does not have a mortgage payment.',
      dataTour: 'refinanceLoan-step-1'},
    {
      type: 'percentage',
      name: 'refinanceDownPayment',
      label: 'Down Payment',
      value: assumptionsInput.refinanceDownPayment || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The amount of cash that a purchaser must put down, toward the purchase price, to buy real estate. The down payment amount is a percentage of the total purchase price, dictated by the lender.',
      dataTour: 'refinanceLoan-step-2'},
    {
      type: 'percentage',
      name: 'refinanceRate',
      label: 'Interest Rate',
      value: assumptionsInput.refinanceRate || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The interest rate is the amount a lender charges for the use of capital, expressed as a percentage of the principal. The interest rate is typically noted on an annual basis known as the annual percentage rate (APR).',
      dataTour: 'refinanceLoan-step-3'},
    {
      type: 'dropdown',
      name: 'refinanceTerm',
      label: 'Financing Term',
      value: assumptionsInput.refinanceTerm || 0,
      adornment: assumptionsInput.refinanceTermType,
      adornmentToggle: assumptionsInput.refinanceTermType,
      adornmentName: 'refinanceTermType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'The length of time that the loan is being amortized. Expressed in months or years.',
      dataTour: 'refinanceLoan-step-4'},
    {
      type: 'number',
      name: 'refinancePoints',
      label: 'Points',
      value: assumptionsInput.refinancePoints || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'Often when you take out a loan, you will pay "points" (aka: fees) on the loan. It is essentially prepaid interest charged by the lender. One point is equal to 1% of the loan amount. For example, a $100,000 loan with 2 points would be $2,000.',
      dataTour: 'refinanceLoan-step-5'},
    {
      type: 'percentage',
      name: 'refinanceCashOut',
      label: 'Cash Out',
      value: assumptionsInput.refinanceCashOut || 0,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        "A lender's limit of how much they will allow you to cash out. Expressed as a percentage of ARV.",
      dataTour: 'refinanceLoan-step-6'},
    {
      type: 'dollar',
      name: 'userCashOut',
      label: 'Actual Cash Out',
      value:
        !analysisInput.userCashOut ||
        analysisInput.userCashOut <= 0 ||
        analysisInput.userCashOut >
          analytics.BRRRR.maxRefinanceLoanAmount -
            analytics.BRRRR.bridgeLoanAmount
          ? analytics.BRRRR.maxRefinanceLoanAmount -
              analytics.BRRRR.bridgeLoanAmount >
            0
            ? analytics.BRRRR.maxRefinanceLoanAmount -
              analytics.BRRRR.bridgeLoanAmount
            : 0
          : analysisInput.userCashOut,
      xs: 12,
      lg: 6,
      tooltipField:
        'The actual amount of money you plan to take out of the loan',
      dataTour: 'refinanceLoan-step-7'},
    {
      type: 'checkbox',
      name: 'refinanceInterestOnlyLoan',
      label: 'Interest Only Loan',
      value: assumptionsInput.refinanceInterestOnlyLoan,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'A loan that only requires the payment of interest, not principal.',
      dataTour: 'refinanceLoan-step-8'},
    // {
    //   type: 'checkbox',
    //   name: 'financingRepairsBRRRR',
    //   label: 'Finance Repairs',
    //   value: analysisInput.financingRepairsBRRRR || false,
    //   xs: 12,
    //   lg: 6,
    //   tooltipField: 'Your down payment adjusts what percentage of your repairs will be financed.',
    //   dataTour: "refinanceLoan-step-9",
    // },
  ]

  const projectionCard =
    find(
      cards,
      (card) =>
        card.name === 'projection' &&
        card.member === activeOrg.member,
    ) ||
    find(
      cards,
      (card) => card.name === 'projection' && card.member === null,
    ) ||
    {}
  const projectionAssumptionsFields = map(
    get(projectionCard, 'card.fields'),
    (field) => {
      const input = field.analytics
        ? analytics.BRRRR
        : field.assumptions
          ? assumptionsInput
          : analysisInput
      const name = field.suffix
        ? includes(field.name, 'Type')
          ? replace(field.name, 'Type', 'BRRRRType')
          : field.name + 'BRRRR'
        : field.name
      const adornmentName =
        field.suffix && field.adornmentName
          ? includes(field.adornmentName, 'Type')
            ? replace(field.adornmentName, 'Type', 'BRRRRType')
            : field.adornmentName + 'BRRRR'
          : field.adornmentName
      const definition =
        field.suffix && field.definition
          ? includes(field.definition, 'Type')
            ? replace(field.definition, 'Type', 'BRRRRType')
            : field.definition + 'BRRRR'
          : field.definition
      return {
        ...field,
        name,
        value: get(input, name),
        adornmentToggle: get(input, adornmentName),
        adornment: get(input, adornmentName),
        adornmentName: adornmentName,
        definition: definition}
    },
  )

  const chartOptions = createCashflowChartOptions(currencyFormat)
  const chartSeries = [
    {
      data: [
        round(sum(grossMonthlyIncomeChartSeries)) || 0,
        round(sum(monthlyExpensesChartSeries)) || 0,
        round(analytics?.BRRRR?.cashFlowBRRRR / 12) || 0,
      ],
      // colors: [
      //   ranges: [
      //     {
      //       from: 100,
      //       to: 0,
      //       color: '#f83145',
      //     },
      //   ],
      // ],
    },
  ]

  const strategySummary = createStrategySummary(
    analytics,
    'BRRRR',
    'BRRRR',
    [
      {
        value: analytics.BRRRR.cashFlowBRRRR / 12 || '-',
        arrow: analytics.BRRRR.cashFlowBRRRRArrow || 0,
        label: 'Net Cashflow',
        type: 'currency',
        target: assumptions.belowCashFlowBRRRR,
        targetLabel: 'Min Net Cashflow Target',
        targetName: 'belowCashFlowBRRRR',
        tourStep: 'targets-step-1',
        min: 100,
        max: 2000,
        minLabel: '$100',
        maxLabel: '$2,000',
        step: 100,
        valueLabelFormat: (x) =>
          x >= 1000 ? `${x / 1000}k` : `${x}`,
        description: `Net cashflow is the amount of money left after the mortgage and any other expenses are paid.`,
        calculation: (
          <>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Gross Annual Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(grossMonthlyIncomeChartSeries) * 12),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Property Mgmt
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.propertyManagementDollarBRRRR,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Maintenance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.BRRRR.maintenanceBRRRRDollar, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Insurance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR
                        .refinancePropertyInsuranceDollar,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Taxes
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analysis.propertyTaxes, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -HOA Fees
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.BRRRR.hoaTotal, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Asset management
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.assetManagementFeeTotalBRRRR,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Utilities
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.utilitiesTypeDollarBRRRR * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Capex
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.monthlyReservesTypeDollarBRRRR *
                        12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Other
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(assumptions.otherExpenseBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Custom Expenses
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.customMonthlyExpenseTotal * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Operating Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.BRRRR.netOperatingIncomeBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            {/* <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Annual Bridge Mortgage
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -{currencyFormat.format(round(analytics.BRRRR.bridgeMortgage * 12, 0))}
                </Typography>
              </Grid>
            </Grid> */}
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Annual Refinance Mortgage
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.BRRRR.refinanceMortgage * 12, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Annual Cashflow
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.BRRRR.cashFlowBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  12 months
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  12
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Monthly Cashflow
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.BRRRR.cashFlowBRRRR / 12, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
          </>
        )},
      {
        value: analytics.BRRRR.cashOnCashReturnBRRRR || '-',
        arrow: analytics.BRRRR.cashOnCashReturnBRRRRArrow || 0,
        label: 'CoC ROI',
        target: assumptions.belowCashOnCashReturnBRRRR,
        targetLabel: 'Min Cash on Cash Return Target',
        targetName: 'belowCashOnCashReturnBRRRR',
        tourStep: 'targets-step-2',
        min: 0,
        max: 30,
        minLabel: '0%',
        maxLabel: '30%',
        description: `A cash-on-cash return calculates the return on the money put in by the investor on a property with a mortgage. Commonly referred to as a Leveraged Return.`,
        calculation: (
          <>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Gross Annual Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(grossMonthlyIncomeChartSeries) * 12),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Property Mgmt
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.propertyManagementDollarBRRRR,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Maintenance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.BRRRR.maintenanceBRRRRDollar, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Insurance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR
                        .refinancePropertyInsuranceDollar,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Taxes
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analysis.propertyTaxes, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -HOA Fees
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.BRRRR.hoaTotal, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Asset management
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.assetManagementFeeTotalBRRRR,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Utilities
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.utilitiesTypeDollarBRRRR * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Capex
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.monthlyReservesTypeDollarBRRRR *
                        12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Other
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(assumptions.otherExpenseBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Custom Expenses
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.customMonthlyExpenseTotal * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Operating Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.BRRRR.netOperatingIncomeBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            {/* <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Annual Bridge Mortgage
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -{currencyFormat.format(round(analytics.BRRRR.bridgeMortgage * 12, 0))}
                </Typography>
              </Grid>
            </Grid> */}
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Annual Refinance Mortgage
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.BRRRR.refinanceMortgage * 12, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Annual Cashflow
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.BRRRR.cashFlowBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  Total Out-of-Pocket
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  {currencyFormat.format(
                    round(analytics.BRRRR.totalOutOfPocketBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Cash on Cash Return
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {percentageFormat.format(
                    analytics.BRRRR.cashOnCashReturnBRRRR,
                  )}
                </Typography>
              </Grid>
            </Grid>
          </>
        )},
      {
        value: analytics.BRRRR.IRRBRRRR || '-',
        arrow: analytics.BRRRR.IRRBRRRRArrow || 0,
        label: 'IRR',
        target: assumptions.belowIRRBRRRR,
        targetLabel: 'Min IRR Target',
        targetName: 'belowIRRBRRRR',
        tourStep: 'targets-step-3',
        min: 0,
        max: 30,
        minLabel: '0%',
        maxLabel: '30%',
        description: `IRR measures an investment’s annual return throughout the entire property ownership time frame. Unlike a cash-on-cash return or cap rate that measures returns in annual segments, IRR weighs total earnings from the day you purchase your property to the day you sell it.`,
        calculation: (
          <>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategySectionLabelSx}>
                  Due to the complexity of this calculation, we only
                  show an overview of what goes into calculating the
                  IRR
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Initial Investment (Out of pocket)
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(analytics.BRRRR.totalOutOfPocketBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Gross Monthly Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(grossMonthlyIncomeChartSeries)),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Rent Growth Rate
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {assumptions.growthRateIncome > 1000
                    ? '+1000%'
                    : assumptions.growthRateIncome}
                  %
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Monthly Expenses
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(monthlyExpensesChartSeries)),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Expenses Growth Rate
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {assumptions.growthRateExpense > 1000
                    ? '+1000%'
                    : assumptions.growthRateExpense}
                  %
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  After Repair Value
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(analytics.BRRRR.arvTotalBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Appreciation Rate
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {assumptions.homePriceAppreciation > 1000
                    ? '+1000%'
                    : assumptions.homePriceAppreciation}
                  %
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Holding Period (years)
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {assumptions.rentalHoldingPeriodBRRRR}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Future property sale
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.refinanceFutureSaleValue,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  IRR
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {analytics.BRRRR.IRRBRRRR > 1000
                    ? '+1000%'
                    : percentageFormat.format(
                        analytics.BRRRR.IRRBRRRR,
                      )}
                </Typography>
              </Grid>
            </Grid>
            {/* <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>-Annual Expenses</Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>-1,308</Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>Net Operating Income</Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>14892</Typography>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon icon={['fal', 'divide']} style={strategyIconGapStyle} />All-in-cost
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon icon={['fal', 'divide']} style={strategyIconGapStyle} />14,892
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid container alignItems="center" justifyContent="space-between" sx={strategyMetricRowSx}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>Cap Rate</Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>12.82%</Typography>
              </Grid>
            </Grid> */}
          </>
        ),
        extraContent: (
          <Grid size={12} sx={strategyMarginBottom10Sx}>
                                  <Box sx={{
                                    "& > .MuiPaper-root": {
                                      overflow: "hidden",
                                      boxShadow: "none !important",
                                      borderRadius: 0,
                                      "&:first-of-type": { borderTopLeftRadius: "0.65rem", borderTopRightRadius: "0.65rem" },
                                      "&:last-of-type": { borderBottomLeftRadius: "0.65rem", borderBottomRightRadius: "0.65rem" },
                                      "&:not(:last-of-type)": { borderBottom: 0 },
                                      "& > .MuiPaper-root": { boxShadow: "none !important", borderRadius: "inherit" },
                                    },
                                    "& .panel-title, & .accordion-toggle, & [data-hf=\"panel-title\"], & [data-hf=\"accordion-toggle\"]": { width: "100%", display: "block" },
                                    "& .MuiCard-root > div:has(> .panel-title), & .MuiCard-root > div:has(> [data-hf=\"panel-title\"])": {
                                      display: "block !important",
                                      padding: "0 !important",
                                      width: "100%",
                                      backgroundColor: "transparent !important",
                                    },
                                    "& > .card": {
                                      overflow: "hidden",
                                      "&:not(:last-of-type)": { borderBottom: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 },
                                      "&:not(:first-of-type)": { borderTopLeftRadius: 0, borderTopRightRadius: 0 },
                                      "& > .card-header": { borderRadius: 0, marginBottom: 0 },
                                    },
                                  }}>
                                    <Card variant="outlined" sx={(accordion === 0) && {
                                      "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                                        borderBottomColor: "rgba(79, 80, 98, 0.3)",
                                        background: "#fff",
                                        color: "#070919 !important",
                                        "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
                                      },
                                      "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
                                    }}>
                                      <Card>
                                        <Box sx={strategyTableRowSx}>
                                          <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                                            <Box data-hf="accordion-toggle" sx={{
                                              "& .MuiButton-root": {
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                textAlign: "left",
                                                fontWeight: 700,
                                                color: "#3b3e66 !important",
                                                textDecoration: "none !important",
                                                textTransform: "none",
                                                borderRadius: 0,
                                                padding: "0.75rem 1.25rem !important",
                                                borderBottom: "1px solid transparent",
                                                background: "#f4f5fd",
                                                "&:hover": {
                                                  background: "#f8f9ff !important",
                                                  color: "#070919 !important",
                                                  textDecoration: "none !important",
                                                  "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                                                },
                                                "&:not(:disabled):hover": { transform: "translateY(0px)" },
                                                "& [data-hf=\"accordion-icon\"]": {
                                                  transform: "rotate(90deg)",
                                                  transition: "all 0.2s ease-in-out",
                                                  marginLeft: "auto",
                                                  color: "#368cff !important",
                                                  overflow: "visible",
                                                },
                                              },
                                              "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                                                background: "#2a2a2a !important",
                                                color: "rgba(255, 255, 255, 0.9) !important",
                                                "&:hover": { background: "#333 !important", color: "#fff !important" },
                                              },
                                            }}>
                                              <Button
                                                variant="text"
                                                size="large"
                                                sx={{
                                                  fontWeight: 700,
                                                  color: "#3b3e66",
                                                  textDecoration: "none",
                                                  "&:hover": {
                                                    backgroundColor: "transparent",
                                                    color: "#4191ff",
                                                    textDecoration: "underline",
                                                    transform: "translateY(0px)",
                                                  },
                                                  "&:active": { textDecoration: "underline", boxShadow: "none" },
                                                  "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                                                  "& span": {
                                                    position: "relative",
                                                    "&::before": {
                                                      content: "\"\"",
                                                      position: "absolute",
                                                      width: "100%",
                                                      height: 2,
                                                      bottom: 0,
                                                      left: 0,
                                                      visibility: "hidden",
                                                      transform: "scaleX(0)",
                                                      transition: "all 0.3s ease-in-out 0s",
                                                    },
                                                    transition: "all 0.2s ease-in-out",
                                                  },
                                                  "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                                                  "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                                                  "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                }}
                                                onClick={() =>
                                                  toggleAccordion(0)
                                                }
                                                aria-expanded={
                                                  accordion === 0
                                                }
                                              >
                                                <span>
                                                  Start Month
                                                </span>
                                                <FontAwesomeIcon icon={[ 'fas', 'angle-up', ]} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                        <Collapse
                                          in={accordion === 0}
                                        >
                                          <Paper sx={strategyFullWidthHiddenSx}>
                                            <TableContainer sx={strategyMaxHeight440Sx}>
                                              <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                              >
                                                <TableHead>
                                                  <TableRow>
                                                    {IRRTableFirstHeaders.map(
                                                      (row) => (
                                                        <TableCell
                                                          align={
                                                            row.align
                                                          }
                                                        >
                                                          {row.name}
                                                        </TableCell>
                                                      ),
                                                    )}
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  <TableRow
                                                    key={
                                                      IRRDataFirst.name
                                                    } sx={strategyTableRowLastSx}>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                    >
                                                      {
                                                        IRRDataFirst.monthYear
                                                      }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {currencyFormat2.format(
                                                        IRRDataFirst.totalOutOfPocket,
                                                      )}
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Paper>
                                        </Collapse>
                                      </Card>
                                    </Card>
                                    <Card variant="outlined" sx={(accordion === 1) && {
                                      "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                                        borderBottomColor: "rgba(79, 80, 98, 0.3)",
                                        background: "#fff",
                                        color: "#070919 !important",
                                        "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
                                      },
                                      "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
                                    }}>
                                      <Card>
                                        <Box sx={strategyTableRowSx}>
                                          <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                                            <Box data-hf="accordion-toggle" sx={{
                                              "& .MuiButton-root": {
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                textAlign: "left",
                                                fontWeight: 700,
                                                color: "#3b3e66 !important",
                                                textDecoration: "none !important",
                                                textTransform: "none",
                                                borderRadius: 0,
                                                padding: "0.75rem 1.25rem !important",
                                                borderBottom: "1px solid transparent",
                                                background: "#f4f5fd",
                                                "&:hover": {
                                                  background: "#f8f9ff !important",
                                                  color: "#070919 !important",
                                                  textDecoration: "none !important",
                                                  "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                                                },
                                                "&:not(:disabled):hover": { transform: "translateY(0px)" },
                                                "& [data-hf=\"accordion-icon\"]": {
                                                  transform: "rotate(90deg)",
                                                  transition: "all 0.2s ease-in-out",
                                                  marginLeft: "auto",
                                                  color: "#368cff !important",
                                                  overflow: "visible",
                                                },
                                              },
                                              "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                                                background: "#2a2a2a !important",
                                                color: "rgba(255, 255, 255, 0.9) !important",
                                                "&:hover": { background: "#333 !important", color: "#fff !important" },
                                              },
                                            }}>
                                              <Button
                                                variant="text"
                                                size="large"
                                                sx={{
                                                  fontWeight: 700,
                                                  color: "#3b3e66",
                                                  textDecoration: "none",
                                                  "&:hover": {
                                                    backgroundColor: "transparent",
                                                    color: "#4191ff",
                                                    textDecoration: "underline",
                                                    transform: "translateY(0px)",
                                                  },
                                                  "&:active": { textDecoration: "underline", boxShadow: "none" },
                                                  "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                                                  "& span": {
                                                    position: "relative",
                                                    "&::before": {
                                                      content: "\"\"",
                                                      position: "absolute",
                                                      width: "100%",
                                                      height: 2,
                                                      bottom: 0,
                                                      left: 0,
                                                      visibility: "hidden",
                                                      transform: "scaleX(0)",
                                                      transition: "all 0.3s ease-in-out 0s",
                                                    },
                                                    transition: "all 0.2s ease-in-out",
                                                  },
                                                  "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                                                  "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                                                  "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                }}
                                                onClick={() =>
                                                  toggleAccordion(1)
                                                }
                                                aria-expanded={
                                                  accordion === 1
                                                }
                                              >
                                                <span>
                                                  Appreciation Months
                                                </span>
                                                <FontAwesomeIcon icon={[ 'fas', 'angle-up', ]} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                        <Collapse
                                          in={accordion === 1}
                                        >
                                          <Paper sx={strategyFullWidthHiddenSx}>
                                            <TableContainer sx={strategyMaxHeight440Sx}>
                                              <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                              >
                                                <TableHead>
                                                  <TableRow>
                                                    {IRRTableHeaders.map(
                                                      (row) => (
                                                        <TableCell
                                                          align={
                                                            row.align
                                                          }
                                                        >
                                                          {row.name}
                                                        </TableCell>
                                                      ),
                                                    )}
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  {IRRData.map(
                                                    (row) => (
                                                      <>
                                                        <TableRow
                                                          key={
                                                            row.name
                                                          } sx={{
                                                            '&:last-child td, &:last-child th':
                                                              {
                                                                border: 0}}}>
                                                          <TableCell
                                                            component="th"
                                                            scope="row"
                                                          >
                                                            {
                                                              row.monthYear
                                                            }
                                                          </TableCell>
                                                          <TableCell align="center">
                                                            {currencyFormat2.format(
                                                              row.income,
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="center">
                                                            {currencyFormat2.format(
                                                              row.expenses,
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="center">
                                                            {currencyFormat2.format(
                                                              row.mortgage,
                                                            )}
                                                          </TableCell>
                                                          <TableCell align="center">
                                                            {currencyFormat2.format(
                                                              row.flow,
                                                            )}
                                                          </TableCell>
                                                        </TableRow>
                                                      </>
                                                    ),
                                                  )}
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Paper>
                                        </Collapse>
                                      </Card>
                                    </Card>
                                    <Card variant="outlined" sx={(accordion === 2) && {
                                      "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                                        borderBottomColor: "rgba(79, 80, 98, 0.3)",
                                        background: "#fff",
                                        color: "#070919 !important",
                                        "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
                                      },
                                      "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
                                    }}>
                                      <Card>
                                        <Box sx={strategyTableRowSx}>
                                          <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                                            <Box data-hf="accordion-toggle" sx={{
                                              "& .MuiButton-root": {
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                textAlign: "left",
                                                fontWeight: 700,
                                                color: "#3b3e66 !important",
                                                textDecoration: "none !important",
                                                textTransform: "none",
                                                borderRadius: 0,
                                                padding: "0.75rem 1.25rem !important",
                                                borderBottom: "1px solid transparent",
                                                background: "#f4f5fd",
                                                "&:hover": {
                                                  background: "#f8f9ff !important",
                                                  color: "#070919 !important",
                                                  textDecoration: "none !important",
                                                  "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                                                },
                                                "&:not(:disabled):hover": { transform: "translateY(0px)" },
                                                "& [data-hf=\"accordion-icon\"]": {
                                                  transform: "rotate(90deg)",
                                                  transition: "all 0.2s ease-in-out",
                                                  marginLeft: "auto",
                                                  color: "#368cff !important",
                                                  overflow: "visible",
                                                },
                                              },
                                              "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                                                background: "#2a2a2a !important",
                                                color: "rgba(255, 255, 255, 0.9) !important",
                                                "&:hover": { background: "#333 !important", color: "#fff !important" },
                                              },
                                            }}>
                                              <Button
                                                variant="text"
                                                size="large"
                                                sx={{
                                                  fontWeight: 700,
                                                  color: "#3b3e66",
                                                  textDecoration: "none",
                                                  "&:hover": {
                                                    backgroundColor: "transparent",
                                                    color: "#4191ff",
                                                    textDecoration: "underline",
                                                    transform: "translateY(0px)",
                                                  },
                                                  "&:active": { textDecoration: "underline", boxShadow: "none" },
                                                  "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                                                  "& span": {
                                                    position: "relative",
                                                    "&::before": {
                                                      content: "\"\"",
                                                      position: "absolute",
                                                      width: "100%",
                                                      height: 2,
                                                      bottom: 0,
                                                      left: 0,
                                                      visibility: "hidden",
                                                      transform: "scaleX(0)",
                                                      transition: "all 0.3s ease-in-out 0s",
                                                    },
                                                    transition: "all 0.2s ease-in-out",
                                                  },
                                                  "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                                                  "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                                                  "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                }}
                                                onClick={() =>
                                                  toggleAccordion(2)
                                                }
                                                aria-expanded={
                                                  accordion === 2
                                                }
                                              >
                                                <span>
                                                  Final Month
                                                </span>
                                                <FontAwesomeIcon icon={[ 'fas', 'angle-up', ]} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                                              </Button>
                                            </Box>
                                          </Box>
                                        </Box>
                                        <Collapse
                                          in={accordion === 2}
                                        >
                                          <Paper sx={strategyFullWidthHiddenSx}>
                                            <TableContainer sx={strategyMaxHeight440Sx}>
                                              <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                              >
                                                <TableHead>
                                                  <TableRow>
                                                    {IRRTableLastHeaders.map(
                                                      (row) => (
                                                        <TableCell
                                                          align={
                                                            row.align
                                                          }
                                                        >
                                                          {row.name}
                                                        </TableCell>
                                                      ),
                                                    )}
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  <TableRow
                                                    key={
                                                      IRRDataLast.name
                                                    } sx={strategyTableRowLastSx}>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                    >
                                                      {
                                                        IRRDataLast.monthYear
                                                      }
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {currencyFormat2.format(
                                                        IRRDataLast.lastMonthCashFlow,
                                                      )}
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Paper>
                                        </Collapse>
                                      </Card>
                                    </Card>
                                  </Box>
                                </Grid>
        )},
      {
        value: analytics.BRRRR.capRateBRRRR || '-',
        arrow: analytics.BRRRR.capRateBRRRRArrow || 0,
        label: 'Yield-on-Cost',
        target: assumptions.belowCapRateBRRRR,
        targetLabel: 'Min Yield on Cost Target',
        targetName: 'belowCapRateBRRRR',
        tourStep: 'targets-step-4',
        min: 0,
        max: 30,
        minLabel: '0%',
        maxLabel: '30%',
        description: `The Yield-on-Cost is the rate of return an investor can expect from an investment in real estate, assuming they pay all cash.`,
        calculation: (
          <>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  Gross Annual Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  {currencyFormat.format(
                    round(sum(grossMonthlyIncomeChartSeries) * 12),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Property Mgmt
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.propertyManagementDollarBRRRR,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Maintenance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.BRRRR.maintenanceBRRRRDollar, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Insurance
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR
                        .refinancePropertyInsuranceDollar,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Taxes
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analysis.propertyTaxes, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -HOA Fees
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(analytics.BRRRR.hoaTotal, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Asset management
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.assetManagementFeeTotalBRRRR,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Utilities
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.utilitiesTypeDollarBRRRR * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Capex
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.BRRRR.monthlyReservesTypeDollarBRRRR *
                        12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Other
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(assumptions.otherExpenseBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -Custom Expenses
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  -
                  {currencyFormat.format(
                    round(
                      analytics.customMonthlyExpenseTotal * 12,
                      0,
                    ),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Net Operating Income
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {currencyFormat.format(
                    round(analytics.BRRRR.netOperatingIncomeBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  All-in-cost
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyMutedTextSx}>
                  <FontAwesomeIcon
                    icon={['fal', 'divide']}
                    style={strategyIconGapStyle}
                  />
                  {currencyFormat.format(
                    round(analytics.BRRRR.allInCostBRRRR, 0),
                  )}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={strategyMutedDividerSx} />
            <Grid
              container
              sx={[strategyMetricRowSx, {
                alignItems: "center",
                justifyContent: "space-between"
              }]}>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  Yield-on-Cost
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={strategyWhiteTextSx}>
                  {analytics.BRRRR.capRateBRRRR > 1000
                    ? '+1000%'
                    : percentageFormat.format(
                        analytics.BRRRR.capRateBRRRR,
                      )}
                </Typography>
              </Grid>
            </Grid>
          </>
        )},
    ],
    {
      belowKey: 'belowTargetBRRRR',
      onKey: 'onTargetBRRRR',
      aboveKey: 'aboveTargetBRRRR'},
  )

  const financials = [
    {
      value: analytics.BRRRR.allInCostBridge,
      label: 'Bridge All-in Cost',
      description:
        'Total amount of initial investment into a property, including renovation and points paid for financing.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Purchase Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(analysis.offerPrice || analysis.listPrice, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.acquisitionCommissionDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Bridge Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.closeCostDollarBridge, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Holding Costs During Bridge Loan
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.holdingExpensesBridge *
                      (assumptions.bridgeTermType === 'Years'
                        ? assumptions.bridgeTerm * 12
                        : assumptions.bridgeTerm),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Bridge Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.bridgePointsAmount, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Amount
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.corTotalBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Owner Reserves
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.ownerReservesBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Acquisition Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customAcquisitionExpenseTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                All-in Cost
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.BRRRR.allInCostBridge, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      value: analytics.BRRRR.totalOutOfPocketBridge,
      label: 'Bridge Total Out-of-Pocket',
      description:
        'Total amount of cash that a buyer has put into a property of his/her own capital.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Bridge Down Payment
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(analytics.BRRRR.bridgeDownPaymentTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.acquisitionCommissionDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Bridge Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.closeCostDollarBridge, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Holding Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.holdingExpensesBridge *
                      (assumptions.bridgeTermType === 'Years'
                        ? assumptions.bridgeTerm * 12
                        : assumptions.bridgeTerm),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Bridge Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.bridgePointsAmount, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Acquisition Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customAcquisitionExpenseTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Credit From Seller
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(assumptions.creditFromSeller, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Amount
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.repairsOutOfPocketBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Total Out-of-Pocket
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.BRRRR.totalOutOfPocketBridge, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      value: analytics.BRRRR.allInCostBRRRR,
      label: 'Refinance All-in Cost',
      description:
        'Total amount of initial investment into a property, including renovation and points paid for financing.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Purchase Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(analysis.offerPrice || analysis.listPrice, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Commission
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.acquisitionCommissionDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Acquisition Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.acquisitionFee, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Bridge Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.closeCostDollarBridge, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Refinance Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.closeCostDollarRefinance, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Holding Costs During Bridge Loan
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.holdingExpensesBridge *
                      (assumptions.bridgeTermType === 'Years'
                        ? assumptions.bridgeTerm * 12
                        : assumptions.bridgeTerm),
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Bridge Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.bridgePointsAmount, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Refinance Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.refinancePointsAmount, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Amount
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.corTotalBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Financing Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.refinancingFeeTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Owner Reserves
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.ownerReservesBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Acquisition Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customAcquisitionExpenseTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                All-in Cost
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.BRRRR.allInCostBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      value: analytics.BRRRR.totalOutOfPocketRefinance,
      label: 'Refinance Total Out-of-Pocket',
      description:
        'Total amount of cash that a buyer has put into a property of his/her own capital.',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Refinance Down Payment
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(analytics.BRRRR.refinanceDownPaymentTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Refinance Closing Costs
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.closeCostDollarRefinance, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Financing Fee
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.refinancingFeeTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Refinance Loan Points
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.refinancePointsAmount, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Total Out-of-Pocket
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.BRRRR.totalOutOfPocketRefinance, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
  ]

  const calculationDialogs = [
    {
      label: 'Cash Needed to Close',
      description: 'Cash needed to buy the property',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Offer Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(analysis.offerPrice)}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Closing Cost
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  analytics.BRRRR.closeCostDollarBridge,
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Cash Needed to Close
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  analytics.BRRRR.closeCostDollarBridge +
                    analysis.offerPrice,
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      label: 'Total Cash Needed',
      description:
        'Cash needed to be spent on the property before it can be sold',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Offer Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(analysis.offerPrice)}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Closing Cost
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  analytics.BRRRR.closeCostDollarBridge,
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Cash Needed to Close
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  analytics.BRRRR.closeCostDollarBridge +
                    analysis.offerPrice,
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Rehab Cost
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(analytics.BRRRR.corTotalBRRRR)}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Total Cash Needed
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  analytics.BRRRR.closeCostDollarBridge +
                    analysis.offerPrice +
                    analytics.BRRRR.corTotalBRRRR,
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      label: 'NOI',
      description: 'Net Operating Income',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Gross Annual Income
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(sum(grossMonthlyIncomeChartSeries) * 12),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Property Mgmt
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.propertyManagementDollarBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Maintenance
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analytics.BRRRR.maintenanceBRRRRDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Insurance
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.propertyInsuranceDollarBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Taxes
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analysis.propertyTaxes, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -HOA Fees
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analytics.BRRRR.hoaTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Asset management
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.assetManagementFeeTotalBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Utilities
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.utilitiesTypeDollarBRRRR * 12,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Capex
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.monthlyReservesTypeDollarBRRRR *
                      12,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Other
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(assumptions.otherExpenseBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Custom Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analytics.customMonthlyExpenseTotal * 12, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Net Operating Income
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.BRRRR.netOperatingIncomeBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      label: 'Cap Rate',
      description:
        'Cap Rate is calculated by dividing the Net Operating Income(NOI) by the offer price',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Gross Annual Income
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(sum(grossMonthlyIncomeChartSeries) * 12),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Property Mgmt
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.propertyManagementDollarBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Maintenance
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analytics.BRRRR.maintenanceBRRRRDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Insurance
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.propertyInsuranceDollarBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Taxes
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analysis.propertyTaxes, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -HOA Fees
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analytics.BRRRR.hoaTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Asset management
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.assetManagementFeeTotalBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Utilities
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.utilitiesTypeDollarBRRRR * 12,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Capex
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.monthlyReservesTypeDollarBRRRR *
                      12,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Other
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(assumptions.otherExpenseBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -Custom Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                -
                {currencyFormat.format(
                  round(analytics.customMonthlyExpenseTotal * 12, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Net Operating Income
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(analytics.BRRRR.netOperatingIncomeBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                <FontAwesomeIcon
                  icon={['fal', 'divide']}
                  style={strategyIconGapStyle}
                />
                Offer Price
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                <FontAwesomeIcon
                  icon={['fal', 'divide']}
                  style={strategyIconGapStyle}
                />
                {currencyFormat.format(
                  analysis.offerPrice ? analysis.offerPrice : 0,
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Cap Rate
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {percentageFormat.format(
                  analysis.offerPrice
                    ? analytics.BRRRR.netOperatingIncomeBRRRR /
                        analysis.offerPrice
                    : 0,
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
    {
      label: 'Cash on Cash Return',
      description: 'Highest Recommended Offer Price',
      calculation: (
        <>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                Property Mgmt
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.propertyManagementDollarBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Maintenance
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.maintenanceBRRRRDollar, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Insurance
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.propertyInsuranceDollarBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Taxes
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analysis.propertyTaxes, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +HOA Fees
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.BRRRR.hoaTotal, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Asset management
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.assetManagementFeeTotalBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Utilities
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.utilitiesTypeDollarBRRRR * 12,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Capex
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(
                    analytics.BRRRR.monthlyReservesTypeDollarBRRRR *
                      12,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Other
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(assumptions.otherExpenseBRRRR, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +Custom Expenses
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                +
                {currencyFormat.format(
                  round(analytics.customMonthlyExpenseTotal * 12, 0),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Cash Flow Before Taxes
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {currencyFormat.format(
                  round(
                    round(sum(grossMonthlyIncomeChartSeries) * 12) -
                      analytics.BRRRR.netOperatingIncomeBRRRR,
                    0,
                  ),
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                <FontAwesomeIcon
                  icon={['fal', 'divide']}
                  style={strategyIconGapStyle}
                />
                Total Cash Needed
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyMutedTextSx}>
                <FontAwesomeIcon
                  icon={['fal', 'divide']}
                  style={strategyIconGapStyle}
                />
                {currencyFormat.format(
                  analytics.BRRRR.closeCostDollarBridge +
                    analysis.offerPrice +
                    analytics.BRRRR.corTotalBRRRR,
                )}
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={strategyMutedDividerSx} />
          <Grid
            container
            sx={[strategyMetricRowSx, {
              alignItems: "center",
              justifyContent: "space-between"
            }]}>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                Cash On Cash
              </Typography>
            </Grid>
            <Grid>
              <Typography sx={strategyWhiteTextSx}>
                {percentageFormat.format(
                  round(
                    round(sum(grossMonthlyIncomeChartSeries) * 12) -
                      analytics.BRRRR.netOperatingIncomeBRRRR,
                    0,
                  ) /
                    (analytics.BRRRR.closeCostDollarBridge +
                      analysis.offerPrice +
                      analytics.BRRRR.corTotalBRRRR),
                )}
              </Typography>
            </Grid>
          </Grid>
        </>
      )},
  ]

  const pepBigPictureFields = [
    {
      sectionName: 'Acquisition',
      fields: filter(
        [
          {
            type: 'dollar',
            name: 'listPrice',
            label: 'List Price',
            value:
              analysisInput.listPrice === null
                ? //? analysisInput.listPrice.toString()
                  ''
                : analysisInput.listPrice.toString(),
            // xs: 6,
            xs: 12,
            lg: 6,
            definition: 'listPrice',
            tooltipField:
              'The price that the seller is asking for this home. *Not necessarily the price that the investor will purchase the home for.',
            tooltipButtonText: 'Asking Price Options',
            adornmentNumber: 1},
          {
            type: 'dollar',
            name: 'offerPrice',
            label: 'Offer Price',
            value:
              analysisInput.offerPrice === null
                ? //? analysisInput.listPrice.toString()
                  ''
                : analysisInput.offerPrice.toString(),
            // helper:
            //   !analysisInput.offerPrice ||
            //   analysisInput.offerPrice === '0'
            //     ? '0% Discount to Price'
            //     : (
            //         (1 -
            //           analysisInput.offerPrice /
            //             analysisInput.listPrice) *
            //         100
            //       ).toFixed(0) + '% Discount to Price',
            // xs: 6,
            xs: 12,
            lg: 6,
            definition: 'offerPrice',
            tooltipField:
              'The price that has been agreed upon by the owner and buyer for the transferring of a property.',
            tooltipButtonText: 'Show Purchase Price data',
            adornmentNumber: 2},
          {
            type: 'select',
            name: 'rehabBRRRRType',
            value: assumptionsInput.rehabBRRRRType,
            label: 'Rehab Type',
            xs: 12,
            options: assumptionsOptions(activeOrg)?.rehabOptions,
            assumptions: true},
          {
            type: 'dollar',
            name: 'rehabCostBRRRR',
            value: analysisInput.rehabCostBRRRR,
            label: 'Est Rehab',
            tooltipButtonText: 'Show Estimated Rehab data',
            xs: 12,
            lg: 6,
            definition: 'rehabCostBRRRR',
            tooltipField:
              'An expense that is incurred when restoring an entity to its normal or near-normal condition.',
            hide:
              assumptionsInput.rehabBRRRRType !== 'singleRehabValue',
            adornmentNumber: 3},
          {
            type: 'budgetLines',
            name: 'detailedRehabCostBRRRR',
            value: analysisInput.detailedRehabCostBRRRR,
            label: 'End Rehab Costs',
            xs: 12,
            options: [
              'Appliances',
              'Cabinets/Vanities',
              'Carpet',
              'Countertops/Sinks/Toilets',
              'Driveway/Decking/Patio',
              'Electrical',
              'Exterior',
              'Flooring',
              'Framing',
              'Insulation/Drywall',
              'Landscaping',
              'Masonry',
              'Mechanical',
              'Molding/Tile/Trim',
              'Paint',
              'Plans/Permits',
              'Plumbing',
              'Roof',
              'Siding/Gutters',
              'Site Prep',
              'Staging',
              'Windows/Doors',
              'Other',
            ],
            hide: assumptionsInput.rehabBRRRRType !== 'detailedRehab',
            adornmentNumber: 3},
          {
            type: 'rehabCalc',
            name: 'rehabCalcTotalBRRRR',
            label: 'Rehab Calculator',
            value: analysisInput.rehabCalcTotalBRRRR,
            xs: 12,
            lg: 6,
            property: property,
            assumptionsInput: assumptionsInput,
            affiliate: props.affiliate,
            hide: assumptionsInput.rehabBRRRRType !== 'rehabCalc',
            adornmentNumber: 3},
          {
            type: 'select',
            name: 'rehabTierBRRRR',
            value: assumptionsInput.rehabTierBRRRR,
            label: 'Rehab Tier',
            tooltipButtonText: 'Show Estimated Rehab data',
            xs: 12,
            lg: 6,
            options: filter(
              activeOrg.rehabTiers,
              (option) =>
                isEmpty(option.showMarkets) ||
                includes(
                  option.showMarkets,
                  analysisInput.marketType ||
                    props.affiliate?.defaultMarketType,
                ),
            ),
            optionName: 'rehabTiers',
            memberOptions: filter(
              activeOrg.memberRehabTiers,
              (option) =>
                isEmpty(option.showMarkets) ||
                includes(
                  option.showMarkets,
                  analysisInput.marketType ||
                    props.affiliate?.defaultMarketType,
                ),
            ),
            dynamicMemberOptions: map(
              filter(
                activeOrg.dynamicMemberRehabTiers,
                (option) =>
                  isEmpty(option.showMarkets) ||
                  includes(
                    option.showMarkets,
                    analysisInput.marketType ||
                      props.affiliate?.defaultMarketType,
                  ),
              ),
              (option) => {
                let breakPointIndex = 0
                const arv = includes(
                  assumptionsInput.strategySpecificFields,
                  'afterRepairValue',
                )
                  ? analysisInput.afterRepairValueBRRRR === null
                    ? null
                    : analysisInput.afterRepairValueBRRRR
                  : analysisInput.afterRepairValue === null
                    ? null
                    : analysisInput.afterRepairValue
                while (
                  option?.breakpoints[breakPointIndex] < arv &&
                  breakPointIndex < option?.breakpoints.length
                ) {
                  breakPointIndex++
                }
                return {
                  ...option,
                  label: `$${option.values[breakPointIndex]}/Sqft`}
              },
            ),
            removeOption: true,
            assumptions: true,
            hide:
              assumptionsInput.rehabBRRRRType !== 'rehabTier' &&
              assumptionsInput.rehabBRRRRType !==
                'flippingAmericaRehab',
            // helper: currencyFormat.format(
            //   analytics.BRRRR.rehabTierValueBRRRR,
            // ),
            adornmentNumber: 3},
          {
            type: 'dropdown',
            name: 'closingCostBRRRR',
            value: assumptionsInput.closingCostBRRRR,
            label: 'Closing Cost',
            adornmentToggle: assumptionsInput.closingCostBRRRRType,
            adornment: assumptionsInput.closingCostBRRRRType,
            adornmentName: 'closingCostBRRRRType',
            xs: 12,
            lg: 6,
            assumptions: true,
            dropdown: true,
            tooltipField:
              'Fees (attorney/title fees, etc) Paid at Closing. Expressed as a dollar amount or precentage of the purchase prices.',
            adornmentNumber: 4},
        ],
        (field) => !field.hide,
      )},
    {
      sectionName: 'Income',
      fields: filter(
        [
          {
            type: 'select',
            name: 'rentType',
            label: 'Rent Type',
            value: assumptionsInput.rentType,
            options: assumptionsOptions(activeOrg)?.rentTypes,
            xs: 12,
            lg: 12,
            assumptions: true},
          {
            type: 'dollar',
            name: `rent.${props.activeUnit}`,
            label: 'Total Rental Income',
            tooltipButtonText: 'Show Total Rent data',
            value:
              analysisInput.rent[props.activeUnit] === null
                ? ''
                : analysisInput.rent[props.activeUnit].toString(),
            // helper:
            //   property.sqft &&
            //   property.sqft[props.activeUnit] &&
            //   analysisInput.rent[props.activeUnit]
            //     ? currencyFormat2.format(
            //         analysisInput.rent[props.activeUnit] /
            //           property.sqft[props.activeUnit],
            //       ) + ' rent per sqft'
            //     : '$0.00 rent per sqft',
            xs: 12,
            lg: 6,
            definition: 'rent',
            // disabled: !isNil(analysisInput.ownerOccupiedBRRRR) && props.activeUnit === analysisInput.ownerOccupiedBRRRR,
            tooltipField:
              "A tenant's monthly payment to a landlord for the use of property or land.",
            hide: assumptionsInput.rentType !== 'singleRent',
            adornmentNumber: 5},
          {
            type: 'dollar',
            name: `rentLow.${props.activeUnit}`,
            label: 'Rent Range Low',
            tooltipButtonText: 'Show Total Rent data',
            value:
              analysisInput.rentLow[props.activeUnit] === null
                ? ''
                : analysisInput.rentLow[props.activeUnit].toString(),
            xs: 12,
            lg: 6,
            definition: 'rent',
            tooltipField: 'Lower end of projected rent',
            hide: assumptionsInput.rentType !== 'rentRange',
            dataTour: '',
            adornmentNumber: 5},
          {
            type: 'dollar',
            name: `rentHigh.${props.activeUnit}`,
            label: 'Rent Range High',
            tooltipButtonText: 'Show Total Rent data',
            value:
              analysisInput.rentHigh[props.activeUnit] === null
                ? ''
                : analysisInput.rentHigh[props.activeUnit].toString(),
            xs: 12,
            lg: 6,
            definition: 'rent',
            tooltipField: 'Higher end of projected rent',
            hide: assumptionsInput.rentType !== 'rentRange',
            dataTour: '',
            adornmentNumber: 5},
          {
            type: 'percentage',
            name: `vacancy.${props.activeUnit}`,
            label: 'Vacancy Rate',
            value: assumptionsInput.vacancy[props.activeUnit],
            xs: 12,
            lg: 6,
            assumptions: true,
            tooltipField:
              'The percentage of time that a property is not rented out during the course of a year.',
            adornmentNumber: 6},
        ],
        (field) => !field.hide,
      )},
    {
      sectionName: 'Expenses',
      fields: sortBy(
        filter(
          map(monthlyExpensesFields, (field) => {
            let adornmentNumber = 0
            if (includes(field.label, 'Taxes')) {
              adornmentNumber = 7
            } else if (includes(field.label, 'Insurance')) {
              adornmentNumber = 8
            } else if (includes(field.label, 'Mgmt Fee')) {
              adornmentNumber = 9
            } else if (includes(field.label, 'Maintenance')) {
              adornmentNumber = 10
            }

            if (adornmentNumber > 0)
              return {
                ...field,
                adornmentNumber}
            else
              return {
                ...field,
                hide: true}
          }),
          (field) => !field.hide,
        ),
        ['adornmentNumber'],
      )},
  ]

  const dispositionFields = [
    {
      type: 'dollar',
      name: 'resellPriceBRRRR',
      label: 'Resale Price',
      value:
        analysisInput.resellPriceBRRRR === null
          ? ''
          : analysisInput.resellPriceBRRRR.toString(),
      xs: 12,
      lg: 6,
      tooltipField:
        'The price you would sell the property for once the rehab is completed.',
      dataTour: 'dispositionExpenses-step-2'},
    {
      type: 'dropdown',
      name: 'sellerClosingCostBRRRR',
      label: 'Seller Closing Cost',
      value: assumptionsInput.sellerClosingCostBRRRR,
      adornmentToggle: assumptionsInput.sellerClosingCostBRRRRType,
      adornment: assumptionsInput.sellerClosingCostBRRRRType,
      adornmentName: 'sellerClosingCostBRRRRType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Closing Costs Paid by the Seller. Expressed as a dollar amount or percentage of the resale price',
      dataTour: 'dispositionExpenses-step-3'},
    {
      type: 'dropdown',
      name: 'salesCommissionBRRRR',
      label: 'Sales Commission',
      value: assumptionsInput.salesCommissionBRRRR,
      adornmentToggle: assumptionsInput.salesCommissionBRRRRType,
      adornment: assumptionsInput.salesCommissionBRRRRType,
      adornmentName: 'salesCommissionBRRRRType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Sales Commission on the Future Sale of Property. Expressed as a dollar amount or percentage of resale price.',
      dataTour: 'dispositionExpenses-step-4'},
    {
      type: 'dropdown',
      name: 'dispositionFeeBRRRR',
      label: 'Disposition Fee',
      value: assumptionsInput.dispositionFeeBRRRR,
      adornmentToggle: assumptionsInput.dispositionFeeBRRRRType,
      adornment: assumptionsInput.dispositionFeeBRRRRType,
      adornmentName: 'dispositionFeeBRRRRType',
      xs: 12,
      lg: 6,
      assumptions: true,
      dropdown: true,
      tooltipField:
        'Advanced Fee - Additional marketing fee on top of sales commission. Expressed as a dollar amount or percentage of resale price.',
      dataTour: 'dispositionExpenses-step-5'},
    {
      type: 'percentage',
      name: 'homePriceAppreciation',
      label: 'Home Price Appreciation',
      value: assumptionsInput.homePriceAppreciation,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The % of Appreciation in Total Dollar Value that the Home has gained or lost each year. Expressed as a percentage of ARV (after repair value). If your holding period is less than 12 months, this field will have no effect.',
      dataTour: 'dispositionExpenses-step-6'},
    {
      type: 'percentage',
      name: 'growthRateExpense',
      label: 'Expense Growth Rate',
      value: assumptionsInput.growthRateExpense,
      xs: 12,
      lg: 6,
      assumptions: true,
      tooltipField:
        'The % increase in property expenses per year. Expressed as a percentage of gross rental income. If your holding period is less than 12 months, this field will have no effect.',
      dataTour: 'dispositionExpenses-step-7'},
    {
      type: 'dollar',
      name: 'loanBalanceAtHoldingPeriodBRRRR',
      label: 'Loan Balance at Resale',
      value:
        analytics.BRRRR.loanBalanceAtHoldingPeriodBRRRR === null
          ? ''
          : analytics.BRRRR.loanBalanceAtHoldingPeriodBRRRR,
      xs: 12,
      lg: 6,
      disabled: true,
      tooltipField:
        'This field is not editable. The remaining loan amount at the end of your flip holding period.',
      dataTour: 'dispositionExpenses-step-8'},
  ]

  const dispositionChartOptions = createDonutChartOptions(
    currencyFormat,
    [
      'Seller Closing Cost',
      'Sales Commission',
      'Disposition Fee',
      'Loan Balance at Resale',
    ],
    pieColors,
  )
  const dispositionChartSeries = [
    round(analytics.BRRRR.sellingClosingCostDollarBRRRR, 2) || 0.0001,
    round(analytics.BRRRR.salesCommissionTotalBRRRR, 2) || 0,
    round(analytics.BRRRR.dispositionFeeDollarBRRRR, 2) || 0,
    round(analytics.BRRRR.loanBalanceAtHoldingPeriodBRRRR, 2) || 0,
  ]

  const compData = calculateCompData({
    compValues: props.compValues,
    lowestAverage: props.lowestAverage})

  const maxCashOut =
    analytics.BRRRR.maxRefinanceLoanAmount -
      analytics.BRRRR.bridgeLoanAmount >
    0
      ? analytics.BRRRR.maxRefinanceLoanAmount -
        analytics.BRRRR.bridgeLoanAmount
      : 0

  const BRRRRCards = [
    {
      name: 'bigPicture',
      hide: !activeOrg.isRealeflow,
      card: (
        <Card variant="outlined" sx={{ width: "100%" }}>
          <Box sx={strategyMetricRowFlexSx}>
            <Box sx={{
              flexGrow: 1,
              minWidth: 0,
              "& > b": { display: "block" },
              "& > small": {
                textTransform: "uppercase",
                display: "block",
                opacity: 0.3,
                fontWeight: "bold",
              },
            }}>
              <b>Big Picture</b>
            </Box>
          </Box>
          <CardContent>
            {map(pepBigPictureFields, (section) => (
              <>
                <Divider sx={strategyMarginBottom5Sx}/>
                <Typography sx={strategyPad5Sx}>
                  {section.sectionName}
                </Typography>
                <Divider sx={strategyMarginBottom5Sx}/>

                <Grid container>
                  <Grid>
                    <Grid
                      container
                      direction="row"
                      // alignItems="center"
                      spacing={1}
                    >
                      {map(section.fields, (section) =>
                        renderInputFields(section),
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </>
            ))}
            <Paper
              elevation={3}
              sx={{ borderRadius: 3, p: 0, background: '#f9fafe' }}
            >
              <Grid container>
                {/* Cash Needed to Close */}
                <Grid size={{xs: 12, md: 6}}
                  onClick={() => toggle1('Cash Needed to Close')}
                  sx={{
                    borderRight: {
                      md: '1px solid #e0e0e0',
                      xs: 'none'},
                    borderBottom: '1px solid #e0e0e0',
                    p: 2}}
                >
                  <Box sx={{
                    textAlign: "center"
                  }}>
                    <Typography
                      variant="subtitle1"
                      color="textSecondary"
                    >
                      Cash Needed to Close
                    </Typography>
                    <Typography variant="h5" sx={{
                      fontWeight: "bold"
                    }}>
                      <CountUp
                        start={0}
                        end={
                          analytics.BRRRR.closeCostDollarBridge +
                          analysisInput.offerPrice
                        }
                        duration={1}
                        separator=","
                        decimals={0}
                        prefix="$"
                      />
                    </Typography>
                  </Box>
                </Grid>
                {/* Total Cash Needed */}
                <Grid size={{xs: 12, md: 6}}
                  onClick={() => toggle1('Total Cash Needed')}
                  sx={{
                    borderBottom: '1px solid #e0e0e0',
                    p: 2}}
                >
                  <Box sx={{
                    textAlign: "center"
                  }}>
                    <Typography
                      variant="subtitle1"
                      color="textSecondary"
                    >
                      Total Cash Needed
                    </Typography>
                    <Typography variant="h5" sx={{
                      fontWeight: "bold"
                    }}>
                      <CountUp
                        start={0}
                        end={
                          analytics.BRRRR.closeCostDollarBridge +
                          analysis.offerPrice +
                          analytics.BRRRR.corTotalBRRRR
                        }
                        duration={1}
                        separator=","
                        decimals={0}
                        prefix="$"
                      />
                    </Typography>
                  </Box>
                </Grid>
                {/* NOI */}
                <Grid size={{xs: 12, md: 6}}
                  onClick={() => toggle1('NOI')}
                  sx={{
                    borderRight: {
                      md: '1px solid #e0e0e0',
                      xs: 'none'},
                    borderBottom: {
                      md: 'none',
                      xs: '1px solid #e0e0e0'},
                    p: 2}}
                >
                  <Box sx={{
                    textAlign: "center"
                  }}>
                    <Typography
                      variant="subtitle1"
                      color="textSecondary"
                    >
                      NOI
                    </Typography>
                    <Typography variant="h5" sx={{
                      fontWeight: "bold"
                    }}>
                      <CountUp
                        start={0}
                        end={analytics.BRRRR.netOperatingIncomeBRRRR}
                        duration={1}
                        separator=","
                        decimals={2}
                        prefix="$"
                      />
                    </Typography>
                  </Box>
                </Grid>
                {/* Cap Rate */}
                <Grid size={{xs: 12, md: 6}}
                  onClick={() => toggle1('Cap Rate')}
                  sx={{
                    borderBottom: {
                      xs: '1px solid #e0e0e0',
                      md: 'none'},
                    p: 2}}
                >
                  <Box sx={{
                    textAlign: "center"
                  }}>
                    <Typography
                      variant="subtitle1"
                      color="textSecondary"
                    >
                      Cap Rate
                    </Typography>
                    <Typography variant="h5" sx={{
                      fontWeight: "bold"
                    }}>
                      <CountUp
                        start={0}
                        end={round(
                          analysis.offerPrice
                            ? (analytics.BRRRR
                                .netOperatingIncomeBRRRR /
                                analysis.offerPrice) *
                                100
                            : 0,
                          2,
                        )}
                        duration={1}
                        separator=","
                        decimals={2}
                        suffix="%"
                      />
                    </Typography>
                  </Box>
                </Grid>
                {/* Cash on Cash Return */}
                <Grid size={12}
                  sx={{
                    borderTop: '1px solid #e0e0e0',
                    p: 2}}
                  onClick={() => toggle1('Cash on Cash Return')}
                >
                  <Box sx={{
                    textAlign: "center"
                  }}>
                    <Typography
                      variant="subtitle1"
                      color="textSecondary"
                    >
                      Cash on Cash Return
                    </Typography>
                    <Typography variant="h5" sx={{
                      fontWeight: "bold"
                    }}>
                      <CountUp
                        start={0}
                        end={
                          (round(
                            round(
                              sum(grossMonthlyIncomeChartSeries) * 12,
                            ) -
                              analytics.BRRRR.netOperatingIncomeBRRRR,
                            0,
                          ) /
                            (analytics.BRRRR.closeCostDollarBridge +
                              analysis.offerPrice +
                              analytics.BRRRR.corTotalBRRRR)) *
                          100
                        }
                        duration={1}
                        separator=","
                        decimals={2}
                        suffix="%"
                      />
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      )},
    // {
    //   name: 'bigPictureSummary',
    //   hide: !activeOrg.isRealeflow,
    //   card: (
    //     <Card>
    //       <div>
    //         <div>
    //           <b>Big Picture Summary</b>
    //         </div>
    //         {/* <div>
    //               <Tooltip title="Quick glance determination seen on the main page">
    //                 <Button onClick={() => setOpenFixFlipStrategyTour(true)}>
    //                   <FontAwesomeIcon icon={['fal', 'info-circle']} />
    //                 </Button>
    //               </Tooltip>
    //             </div> */}
    //       </div>
    //       <Divider />
    //       <div>
    //         <Grid
      //           container
      //
      //           // onClick={() =>
      //           //   toggle1('Property Edge Pro - Max Offer Price')
      //           // }
      //         >
      //           <Grid size={{md: 6}}
      //
      //
      //
      //             onClick={() => toggle1('Cash Needed to Close')}
      //           >
      //             <div data-tour="financing-step-1">
      //               <div>
      //                 Cash Needed to Close
      //               </div>
      //               <div>
      //                 <div>
      //                   {/* <div>
      //                         fast
      //                       </div> */}
      //                   <span>
      //                     <CountUp
      //                       start={0}
      //                       end={
      //                         analytics.BRRRR.closeCostDollarBridge +
      //                         analysisInput.offerPrice
      //                       }
      //                       duration={1}
      //                       separator=","
      //                       decimals={0}
      //                       prefix="$"
      //                     />
      //                   </span>
      //                 </div>
      //               </div>
      //             </div>
      //           </Grid>
      //           <Grid size={{md: 6}}
      //
      //
      //
      //             onClick={() => toggle1('Total Cash Needed')}
      //           >
      //             <div data-tour="financing-step-2">
      //               <div>
      //                 Total Cash Needed
      //               </div>
      //               <div>
      //                 <div>
      //                   {/* <div>
      //                         normal
      //                       </div> */}
      //                   <span>
      //                     <CountUp
      //                       start={0}
      //                       end={
      //                         analytics.BRRRR.closeCostDollarBridge +
      //                         analysis.offerPrice +
      //                         analytics.BRRRR.corTotalBRRRR
      //                       }
      //                       duration={1}
      //                       delay={2}
      //                       separator=","
      //                       decimals={0}
      //                       prefix="$"
      //                     />
      //                   </span>
      //                 </div>
      //               </div>
      //             </div>
      //           </Grid>
      //           <Grid size={{md: 6}}
      //
      //
      //
      //             onClick={() => toggle1('NOI')}
      //           >
      //             <div data-tour="financing-step-1">
      //               <div>NOI</div>
      //               <div>
      //                 <div>
      //                   {/* <div>
      //                         fast
      //                       </div> */}
      //                   <span>
      //                     <CountUp
      //                       start={0}
      //                       end={
      //                         analytics.BRRRR.netOperatingIncomeBRRRR
      //                       }
      //                       duration={1}
      //                       separator=","
      //                       decimals={2}
      //                       prefix="$"
      //                     />
      //                   </span>
      //                 </div>
      //               </div>
      //             </div>
      //           </Grid>
      //           <Grid size={{md: 6}}
      //
      //
      //
      //             onClick={() => toggle1('Cap Rate')}
      //           >
      //             <div data-tour="financing-step-2">
      //               <div>Cap Rate</div>
      //               <div>
      //                 <div>
      //                   {/* <div>
      //                         normal
      //                       </div> */}
      //                   <span>
      //                     <CountUp
      //                       start={0}
      //                       end={round(
      //                         analysis.offerPrice
      //                           ? (analytics.BRRRR
      //                               .netOperatingIncomeBRRRR /
      //                               analysis.offerPrice) *
      //                               100
      //                           : 0,
      //                         2,
      //                       )}
      //                       duration={1}
      //                       delay={2}
      //                       separator=","
      //                       decimals={2}
      //                       suffix="%"
      //                     />
      //                   </span>
      //                 </div>
      //               </div>
      //             </div>
      //           </Grid>
      //           <Grid size={{md: 6}}
      //
      //
      //
      //             onClick={() => toggle1('Cash on Cash Return')}
      //           >
      //             <div data-tour="financing-step-1">
      //               <div>
      //                 Cash on Cash Return
      //               </div>
      //               <div>
      //                 <div>
      //                   {/* <div>
      //                         fast
      //                       </div> */}
      //                   <span>
      //                     <CountUp
      //                       start={0}
      //                       end={round(
      //                         analytics.BRRRR.closeCostDollarBridge +
      //                           analysis.offerPrice +
      //                           analytics.BRRRR.corTotalBRRRR !==
      //                           0
      //                           ? ((round(
      //                               sum(grossMonthlyIncomeChartSeries) *
      //                                 12,
      //                             ) -
      //                               analytics.BRRRR
      //                                 .netOperatingIncomeBRRRR) /
      //                               (analytics.BRRRR
      //                                 .closeCostDollarBRRRR +
      //                                 analysis.offerPrice +
      //                                 analytics.BRRRR.corTotalBRRRR)) *
      //                               100
      //                           : 0,
      //                         2,
      //                       )}
      //                       duration={1}
      //                       separator=","
      //                       decimals={2}
      //                       suffix="%"
      //                     />
      //                   </span>
      //                 </div>
      //               </div>
      //             </div>
      //           </Grid>
      //         </Grid>
      //       </div>
      //     </Card>
      //   ),
      // },
      {
      name: 'strategy',
      card: (
      <StrategyCard
      strategyName="BRRRR"
      activeOrg={activeOrg}
      percentage={strategySummary.percentage}
      onStrategyTourClick={toggleStrategyTour}
      shared={props.shared}
      property={property}
      canDrag={props.canDrag}
      contactAgent={
      !props.shared &&
      activeOrg.member !== 'gorillacapital' ? (
      <Box sx={strategyCardBodyPadSx}>
      <ContactAgent
      property={property}
      propertyPage={true}
      canDrag={props.canDrag}
      />
      </Box>
      ) : null
      }
      />
      )},
      {
      name: 'targets',
      card: (
      <TargetsCard
      strategySummary={strategySummary}
      currencyFormat={currencyFormat}
      percentageFormat={percentageFormat}
      modal1={modal1}
      toggle1={toggle1}
      toggle1Close={toggle1Close}
      renderInputFields={renderInputFields}
      assumptionsInput={assumptionsInput}
      maxOfferPrice={analytics.BRRRR.maxBRRRRPrice}
      toggleMaxOffer={toggleMaxOffer}
      maxOfferDescription={maxOfferDescription}
      onTargetsTourClick={toggleTargetsTour}
      maxOfferCalculation={
      <>
      <Grid
      container
      sx={[strategyMetricRowSx, {
      alignItems: "center",
      justifyContent: "space-between"
      }]}>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      Purchase Price:
      </Typography>
      </Grid>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      {currencyFormat.format(
      analysisInput.offerPrice
      ? analysisInput.offerPrice
      : analysisInput.listPrice,
      )}
      </Typography>
      </Grid>
      </Grid>
      <Grid
      container
      sx={[strategyMetricRowSx, {
      alignItems: "center",
      justifyContent: "space-between"
      }]}>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      ARV:
      </Typography>
      </Grid>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      {currencyFormat.format(
      analytics.BRRRR.arvTotalBRRRR,
      )}
      </Typography>
      </Grid>
      </Grid>
      <Grid
      container
      sx={[strategyMetricRowSx, {
      alignItems: "center",
      justifyContent: "space-between"
      }]}>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      All In Cost:
      </Typography>
      </Grid>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      {currencyFormat.format(
      analytics.BRRRR.allInCostBRRRR,
      )}
      </Typography>
      </Grid>
      </Grid>
      <Grid
      container
      sx={[strategyMetricRowSx, {
      alignItems: "center",
      justifyContent: "space-between"
      }]}>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      Total Out Of Pocket:
      </Typography>
      </Grid>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      {currencyFormat.format(
      analytics.BRRRR.totalOutOfPocketBRRRR,
      )}
      </Typography>
      </Grid>
      </Grid>
      <Grid
      container
      sx={[strategyMetricRowSx, {
      alignItems: "center",
      justifyContent: "space-between"
      }]}>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      Annual Cash Flow:
      </Typography>
      </Grid>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      {currencyFormat.format(
      analytics.BRRRR.cashFlowBRRRR,
      )}
      </Typography>
      </Grid>
      </Grid>
      <Grid
      container
      sx={[strategyMetricRowSx, {
      alignItems: "center",
      justifyContent: "space-between"
      }]}>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      Holding Period (yr):
      </Typography>
      </Grid>
      <Grid>
      <Typography sx={strategyMutedTextSx}>
      {
      assumptionsInput.rentalHoldingPeriodBRRRR
      }
      </Typography>
      </Grid>
      </Grid>
      </>
      }
      />
      )},
      {
      name: 'monthlyCashflow',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }}>
      <Box sx={strategyTableRowSx}>
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <Box component="small" sx={strategyUppercaseMetaSx}>
      Summary
      </Box>
      <b>Monthly Cashflow</b>
      </Box>
      <div>
      <Tooltip title="Shows the income, expenses, and projected overall cashflow of the property">
      <Button
      onClick={() =>
      setOpenBRRRRMonthlyCashflowTour(true)
      }
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </div>
          </Box>
      <Divider />
      <CardContent>
      <Box sx={{
        borderRadius: "0.65rem",
        p: 1.5,
        mb: 1,
        bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
        textAlign: "center",
        border: "1px solid rgba(59, 62, 102, 0.1)",
        "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 1.25,
          py: 0.75,
          gap: 0.25,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
        "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
          minHeight: "2.6em",
          lineHeight: 1.3,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          px: 0.5,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
          color: "#070919",
          fontWeight: 700,
          fontSize: "1.15rem",
          lineHeight: 1.2,
        },
      }}>
      <Grid container sx={{ color: "rgba(59, 62, 102, 0.5)" }}>
      <Grid
      size={{ xs: 4 }}
      data-tour="monthlyCashflow-step-1"
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>Income</Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      <Box component="span" sx={strategyMetricDotGreenSx}>
      fast
      </Box>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      sum(grossMonthlyIncomeChartSeries) /
      1000
      }
      duration={1}
      delay={2}
      decimals={1}
      decimal="."
      prefix="$"
      suffix="k"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid
      size={{ xs: 4 }}
      data-tour="monthlyCashflow-step-2"
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>Expenses</Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      <Box component="span" sx={strategyMetricDotRedSx}>
      normal
      </Box>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      sum(monthlyExpensesChartSeries) / 1000
      }
      duration={1}
      delay={2}
      decimals={1}
      decimal="."
      prefix="$"
      suffix="k"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid
      size={{ xs: 4 }}
      data-tour="monthlyCashflow-step-3"
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>Cashflow</Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      <Box component="span" sx={strategyMetricDotBlueSx}>
      slow
      </Box>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      analytics.BRRRR.cashFlowBRRRR /
      12 /
      1000
      }
      duration={1}
      delay={2}
      decimals={1}
      decimal="."
      prefix="$"
      suffix="k"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      </Grid>
      </Box>
      <>
      <Suspense fallback={<LoadingSkeleton variant="chart" />}>
      <Box sx={{ width: '100%', minWidth: 0, overflow: 'visible' }}>
      <Chart
      options={chartOptions}
      series={chartSeries}
      type="bar"
      width="100%"
      height={250}
      />
      </Box>
      </Suspense>
      </>
      </CardContent>
      </Card>
      ),
      },

      {
      name: 'acquisition',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }}>
      <Box sx={strategyMetricRowFlexSx}>
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <b>Acquisition Expenses</b>
      </Box>
      <div>
      <Tooltip title="The total projected expenses required to purchase the property">
      <Button
      onClick={() =>
      setOpenBRRRRAcquisitionExpensesTour(true)
      }
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </div>
      </Box>
      <Divider />
      <CardContent>
      <Grid>
      <Grid>
      <Box sx={strategyFlexCenterOnlySx}>
      <Suspense fallback={<LoadingSkeleton variant="chart" />}>
      <Chart
      options={acquisitionChartOptions}
      series={acquisitionChartSeries}
      type="donut"
      width="300"
      />
      </Suspense>
      </Box>
      </Grid>
      <Divider sx={strategyBlockSpacerSx} />
      <Grid>
      <Grid
      container
      direction="row"
      /*alignItems='center'*/ spacing={1}
      >
      <Grid
      size={12}
      container
      wrap="nowrap"
      sx={{
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      }}
      >
      <Grid data-tour="acquisitionExpenses-step-1">
      <FormGroup row>
      <FormControlLabel
      control={
      <Checkbox
      id="Advanced Fields"
      checked={state.checkedA}
      onChange={handleChange}
      name="checkedA"
      />
      }
      label="Advanced Fields"
      />
      </FormGroup>
      </Grid>
      {(!props.publicDashboard ||
      !property.hideDaysOnMarketplace) && (
      <Grid
      data-tour="acquisitionExpenses-step-2"
      >
      <Tooltip title="Refers to the number of days a house is listed on the market and the day it is sold.">
      <Typography sx={strategyTableCellRightSx}>
      <FontAwesomeIcon
      icon={['far', 'clock']}
      style={strategyIconGap5Style}
      />
      {analysisInput.daysOnMarket} days on
      market
      </Typography>
      </Tooltip>
      </Grid>
      )}
      </Grid>
      {map(
      state.checkedA
      ? concat(
      basicAcquisitionFields,
      advancedAcquisitionFields,
      customAcquisitonField,
      )
      : concat(
      basicAcquisitionFields,
      customAcquisitonField,
      ),
      (field) => renderInputFields(field),
                  )}
      </Grid>
      </Grid>
      </Grid>
      </CardContent>
      </Card>
      )},
      {
      name: 'income',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }} sx={strategyFullWidthSx}>
      <Grid
      container
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        py: "0.75rem",
        px: "1.25rem",
        mb: 0,
        backgroundColor: "#fff",
        "html[data-color-mode=\"dark\"] &": { backgroundColor: "#1e1e1e !important", color: "rgba(255, 255, 255, 0.87)" },
      }}>
      <Grid size={8} sx={{ minWidth: 0 }}>
      <List sx={{
        display: "flex",
        alignItems: "stretch",
        gap: 0.5,
        p: 0,
        m: 0,
        minHeight: 40,
      }}>
      {analysisInput.rent.length > 1 ? (
      map(analysisInput.rent, (value, index) => (
      <ListItemButton
      key={`unit-${index}`}
      selected={props.activeUnit === index}
      onClick={() => props.setActiveUnit(index)}
      sx={{
        width: "auto",
        minWidth: "auto",
        px: 1.5,
        py: 1,
        minHeight: 40,
        borderRadius: 0,
        color: "#4f5062",
        fontWeight: 500,
        "&.Mui-selected": {
          color: "#368cff",
          fontWeight: 700,
          bgcolor: "transparent",
          borderBottom: "3px solid #368cff",
        },
        "&.Mui-selected:hover": { bgcolor: "transparent", color: "#368cff" },
      }}
      >
      Unit {index + 1}
      </ListItemButton>
      ))
      ) : (
      <ListItem
      sx={strategyFullWidthSx} sx={{ my: "0.25rem" }}
      >
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <b>Gross Monthly Income</b>
      </Box>
      </ListItem>
      )}
      </List>
      </Grid>
      <Grid style={strategyIconGap20Style}>
      <Tooltip title="Total income generated from the property on a monthly basis">
      <Button
      onClick={() =>
      setOpenBRRRRGrossMonthlyIncomeTour(true)
      }
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </Grid>
      </Grid>
      <Divider />
      <CardContent>
      <Grid>
      <Grid>
      <Box sx={strategyFlexCenterOnlySx}>
      <Suspense fallback={<LoadingSkeleton variant="chart" />}>
      <Chart
      options={grossMonthlyIncomeChartOptions}
      series={grossMonthlyIncomeChartSeries}
      type="donut"
      width="300"
      />
      </Suspense>
      </Box>
      </Grid>
      <Divider sx={strategyBlockSpacerSx} />
      <Grid>
      <Grid
      container
      direction="row"
      spacing={1}
      sx={{ alignItems: 'flex-start' }}
      >
      {map(grossMonthlyIncomeFields, (field) =>
      renderInputFields(field),
      )}
      </Grid>
      </Grid>
      </Grid>
      </CardContent>
      </Card>
      )},
      {
      name: 'expenses',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }}>
      <Box sx={strategyMetricRowFlexSx}>
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <b>Monthly Expenses</b>
      </Box>
      <div>
      <Tooltip title="Projected monthly expenditures and applicable costs associated with the property">
      <Button
      onClick={() =>
      setOpenBRRRRMonthlyExpensesTour(true)
      }
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </div>
      </Box>
      <Divider />
      <CardContent>
      <Grid>
      <Grid>
      <Box sx={strategyFlexCenterOnlySx}>
      <Suspense fallback={<LoadingSkeleton variant="chart" />}>
      <Chart
      options={monthlyExpensesChartOptions}
      series={monthlyExpensesChartSeries}
      type="donut"
      width="300"
      />
      </Suspense>
      </Box>
      </Grid>
      <Divider sx={strategyBlockSpacerSx} />
      <Grid>
      <Grid
      container
      direction="row"
      spacing={1}
      sx={{ alignItems: 'center' }}
      >
      {map(monthlyExpensesFields, (field) =>
      renderInputFields(field),
      )}
      </Grid>
      </Grid>
      <Grid>
      <Grid container direction="row" spacing={1}>
      {!isEmpty(property.propertyManagementGroups) && (
      <Grid size={12}>
      <Button
      fullWidth={true}
      variant="outlined"
      size="small"
      color="primary"
      onClick={handleOpenManagementCompanies}
      >
      Property Management Companies
      </Button>
      </Grid>
      )}
      </Grid>
      </Grid>
      </Grid>
      </CardContent>
      </Card>
      )},
      {
      name: 'rehab',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }} sx={strategyFullWidthSx}>
      <Box sx={strategyMetricRowFlexSx}>
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <b>Rehab Expenses</b>
      </Box>
      <div>
      <Tooltip title="Estimated expenses allocated to the renovations of a property">
      <Button
      onClick={() => setOpenBRRRRRehabExpensesTour(true)}
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </div>
      </Box>
      <Divider />
      <CardContent>
      <Grid>
      <Grid>
      <Box sx={strategyFlexCenterOnlySx}>
      <Suspense fallback={<LoadingSkeleton variant="chart" />}>
      <Chart
      options={rehabChartOptions}
      series={rehabChartSeries}
      type="donut"
      width="300"
      />
      </Suspense>
      </Box>
      </Grid>
      <Divider sx={strategyBlockSpacerSx} />
      <Grid>
      <Grid
      container
      direction="row"
      spacing={1}
      sx={{ alignItems: 'center' }}
      >
      {map(rehabFields, (field) =>
      renderInputFields(field),
      )}
      </Grid>
      </Grid>
      </Grid>
      </CardContent>
      </Card>
      )},
      {
      name: 'financing',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }}>
      {/* <div style={{ marginBottom: 5, marginTop: 5 }}>
      <div>
      <b>Financingg</b>
      </div>
      <div>
      <Tooltip title="Projected fund totals an investor will need to produce in order to acquire the property">
      <Button>
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </div>
      </div> */}
      <Grid
      container
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        py: "0.75rem",
        px: "1.25rem",
        mb: 0,
        backgroundColor: "#fff",
        "html[data-color-mode=\"dark\"] &": { backgroundColor: "#1e1e1e !important", color: "rgba(255, 255, 255, 0.87)" },
      }}>
      <Grid sx={{ minWidth: 0, overflowX: 'auto' }}>
      <List component="div" disablePadding sx={[{ display: "flex" }, {
        paddingTop: 0,
        paddingBottom: 0,
        "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root, & > .MuiListItem-root": {
          color: "#a6a6b9",
          position: "relative",
          transition: "all 0.2s ease-in-out",
          padding: "0.75rem 1.25rem 1rem",
          background: "transparent",
          width: "auto",
          minHeight: 48,
          margin: 0,
          borderRadius: 0,
          alignItems: "center",
          alignSelf: "stretch",
          boxSizing: "border-box",
          "& .divider": {
            width: "100%",
            borderRadius: "0.75rem",
            height: 3,
            background: "#368cff",
            visibility: "hidden",
            opacity: 0,
            transform: "translateY(-10px)",
            transition: "all 0.2s ease-in-out",
            position: "absolute",
            left: 0,
            bottom: 0,
          },
          "&:hover": { color: "#000", background: "transparent" },
          "&.Mui-selected": {
            color: "#368cff",
            background: "transparent",
            "&:hover": { color: "#368cff" },
            "& .divider": { visibility: "inherit", opacity: 1, transform: "translateY(0)" },
            fontWeight: 700,
          },
        },
        position: "relative",
        zIndex: 4,
        padding: 0,
        "&::after": {
          background: "#f4f5fd",
          height: 3,
          borderRadius: "0.75rem",
          display: "block",
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          content: "\"\"",
          zIndex: 5,
        },
        "& .MuiListItem-root.MuiListItem-button + .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root + .MuiListItemButton-root": { marginLeft: "2rem" },
        "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": {
          padding: "0.75rem 0 1rem",
          margin: 0,
          "& .divider": { zIndex: 8, left: 0, width: "100%" },
        },
      }]}>
      <ListItemButton
      disableRipple
      selected={activeTab === '0'}
      onClick={() => {
      toggle('0')
      }}
      >
      <Box component="span" sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      Bridge Loan
      </Box>
      <Box sx={{ background: "#eeeff8", height: "1px", overflow: "hidden" }} />
      </ListItemButton>
      <ListItemButton
      disableRipple
      selected={activeTab === '1'}
      onClick={() => {
      toggle('1')
      }}
      >
      <Box component="span" sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      Refinance Loan
      </Box>
      <Box sx={{ background: "#eeeff8", height: "1px", overflow: "hidden" }} />
      </ListItemButton>
      </List>
      </Grid>
      <Grid>
      <Tooltip title="Projected fund totals an investor will need to produce in order to acquire the property">
      <Button
      onClick={() =>
      activeTab === '0'
      ? setOpenBRRRRBridgeLoanTour(true)
      : setOpenBRRRRRefinanceLoanTour(true)
      }
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
        mr: "1.5rem",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </Grid>
      </Grid>
      <Divider />
      <CardContent>
      {activeTab === '0' && (
      <>
      <Grid
      container
      sx={{
        borderRadius: "0.65rem",
        p: 1.5,
        mb: 1,
        bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
        textAlign: "center",
        border: "1px solid rgba(59, 62, 102, 0.1)",
        "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 1.25,
          py: 0.75,
          gap: 0.25,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
        "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
          minHeight: "2.6em",
          lineHeight: 1.3,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          px: 0.5,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
          color: "#070919",
          fontWeight: 700,
          fontSize: "1.15rem",
          lineHeight: 1.2,
        },
      }}
      >
      <Grid
      size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>Loan</Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      {/* <div>
      fast
      </div> */}
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={analytics.BRRRR.bridgeLoanAmount}
      duration={1}
      separator=","
      decimals={0}
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid
      size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>
      Mortgage/mo
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      {/* <div>
      normal
      </div> */}
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={analytics.BRRRR.bridgeMortgage}
      duration={1}
      delay={2}
      separator=","
      decimals={0}
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid
      size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>DSCR</Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      {/* <div>
      slow
      </div> */}
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      analytics.BRRRR
      .debtCoverageRatioBridge
      }
      duration={1}
      delay={2}
      separator=","
      decimals={2}
      suffix="x"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      </Grid>
      <Box component="p" sx={strategySubtitleCenterSx}>
      Based on your{' '}
      <b>
      {currencyFormat.format(
      analytics.BRRRR.allInCostBridge,
      )}
      </b>{' '}
      <Tooltip title="The total amount of money this deal costs, including rehab, closing costs, points, etc.">
      <Box component="span"
      onClick={() => toggle1('Bridge All-in Cost')}
      sx={strategyTooltipLinkSx}
      >
      all-in cost
      </Box>
      </Tooltip>
      , you'll need to pay{' '}
      <b>
      {currencyFormat.format(
      analytics.BRRRR.totalOutOfPocketBridge,
      )}
      </b>{' '}
      <Tooltip title="Total amount that the buyer has to cover with their own money.">
      <Box component="span"
      onClick={() =>
      toggle1('Bridge Total Out-of-Pocket')
      }
      sx={strategyTooltipLinkSx}
      >
      out-of-pocket
      </Box>
      </Tooltip>{' '}
      to cover the downpayment, closing costs, and rehab
      for this property.
      </Box>
      <Divider
      sx={strategyBlockSpacerSx}
      />
      <Grid container>
      <Grid>
      <Grid
      container
      direction="row"
      spacing={1}
      sx={{ alignItems: 'center' }}
      >
      {map(financingFields, (section) =>
      renderInputFields(section),
      )}
      </Grid>
      </Grid>
      </Grid>
      </>
      )}
      {activeTab === '1' && (
      <>
      <Grid
      container
      sx={{
        borderRadius: "0.65rem",
        p: 1.5,
        mb: 1,
        bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
        textAlign: "center",
        border: "1px solid rgba(59, 62, 102, 0.1)",
        "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 1.25,
          py: 0.75,
          gap: 0.25,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
        "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
          minHeight: "2.6em",
          lineHeight: 1.3,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          px: 0.5,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
          color: "#070919",
          fontWeight: 700,
          fontSize: "1.15rem",
          lineHeight: 1.2,
        },
      }}
      >
      <Grid
      size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>Loan</Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      {/* <Box sx={{
        display: "inline-block",
        py: 0,
        px: "0.7em",
        fontSize: "70%",
        fontWeight: 700,
        lineHeight: "21px",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "baseline",
        borderRadius: "100%",
        textTransform: "uppercase",
        height: 10,
        color: "#fff",
        backgroundColor: "#1bc943",
        textIndent: "-999rem",
        width: 10,
        p: 0,
        boxShadow: "0 0 0 2px #fff",
        mr: "0.5rem",
      }}>
      fast
      </Box> */}
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      analytics.BRRRR.refinanceLoanAmount
      }
      duration={1}
      separator=","
      decimals={0}
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid
      size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>
      Mortgage/mo
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      {/* <Box sx={{
        display: "inline-block",
        py: 0,
        px: "0.7em",
        fontSize: "70%",
        fontWeight: 700,
        lineHeight: "21px",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "baseline",
        borderRadius: "100%",
        textTransform: "uppercase",
        height: 10,
        color: "#fff",
        backgroundColor: "#f4772e",
        textIndent: "-999rem",
        width: 10,
        p: 0,
        boxShadow: "0 0 0 2px #fff",
        mr: "0.5rem",
      }}>
      normal
      </Box> */}
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={analytics.BRRRR.refinanceMortgage}
      duration={1}
      delay={2}
      separator=","
      decimals={0}
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid
      size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>
      Max Cash Out
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={maxCashOut}
      duration={1}
      delay={2}
      separator=","
      decimals={0}
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      </Grid>
      <Box component="p" sx={strategySubtitleCenterSx}>
      Based on your{' '}
      <b>
      {currencyFormat.format(
      analytics.BRRRR.allInCostBRRRR,
      )}
      </b>{' '}
      <Tooltip title="The total amount of money this deal costs, including rehab, closing costs, points, etc.">
      <Box component="span"
      onClick={() => toggle1('Refinance All-in Cost')}
      sx={strategyTooltipLinkSx}
      >
      all-in cost
      </Box>
      </Tooltip>
      , you will be able to pull out up to{' '}
      <b>{currencyFormat.format(maxCashOut)}</b> of your{' '}
      <b>
      {currencyFormat.format(
      analytics.BRRRR.totalOutOfPocketBridge,
      )}
      </b>{' '}
      <Tooltip title="Total amount that the buyer has to cover with their own money.">
      <Box component="span"
      onClick={() =>
      toggle1('Bridge Total Out-of-Pocket')
      }
      sx={strategyTooltipLinkSx}
      >
      out-of-pocket
      </Box>
      </Tooltip>{' '}
      invested into this property, leaving{' '}
      <b>
      {currencyFormat.format(
      analytics.BRRRR.totalOutOfPocketBridge -
      maxCashOut >
      0
      ? analytics.BRRRR.totalOutOfPocketBridge -
      maxCashOut >
      0
      : 0,
      )}
      </b>{' '}
      in the deal. You will be required to bring{' '}
      <b>
      {currencyFormat.format(
      analytics.BRRRR.totalOutOfPocketRefinance,
      )}
      </b>{' '}
      <Tooltip title="Total amount that the buyer has to cover with their own money.">
      <Box component="span"
      onClick={() =>
      toggle1('Refinance Total Out-of-Pocket')
      }
      sx={strategyTooltipLinkSx}
      >
      additional
      </Box>
      </Tooltip>{' '}
      to the closing to refinance this deal.
      </Box>
      <Divider
      sx={strategyBlockSpacerSx}
      />
      <Grid container>
      <Grid>
      <Grid
      container
      direction="row"
      spacing={1}
      sx={{ alignItems: 'center' }}
      >
      {map(refinancingFields, (section) =>
      renderInputFields(section),
      )}
      </Grid>
      </Grid>
      </Grid>
      </>
      )}
      </CardContent>
      </Card>
      )},
      {
      name: 'projection',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }}>
      <Box sx={strategyMetricRowFlexSx}>
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <b>Value Over Time</b>
      </Box>
      <div>
      <Tooltip title="Projected paydown timelines and cashflow options available on this property">
      <Button
      onClick={() => setOpenBRRRRValueOverTimeTour(true)}
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </div>
      </Box>
      <Divider />
      <CardContent>
      <Box sx={{
        borderRadius: "0.65rem",
        p: 1.5,
        mb: 1,
        bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
        textAlign: "center",
        border: "1px solid rgba(59, 62, 102, 0.1)",
        "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 1.25,
          py: 0.75,
          gap: 0.25,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
        "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
          minHeight: "2.6em",
          lineHeight: 1.3,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          px: 0.5,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
          color: "#070919",
          fontWeight: 700,
          fontSize: "1.15rem",
          lineHeight: 1.2,
        },
      }}>
      <Grid container sx={{ color: "rgba(59, 62, 102, 0.5)" }}>
      <Grid size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div data-tour="valueOverTime-step-1">
      <Box sx={strategyFieldLabelSx}>
      Property Paid off
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      {/* <Box sx={{
        display: "inline-block",
        py: 0,
        px: "0.7em",
        fontSize: "70%",
        fontWeight: 700,
        lineHeight: "21px",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "baseline",
        borderRadius: "100%",
        textTransform: "uppercase",
        height: 10,
        color: "#fff",
        backgroundColor: "#1bc943",
        textIndent: "-999rem",
        width: 10,
        p: 0,
        boxShadow: "0 0 0 2px #fff",
        mr: "0.5rem",
      }}>
      fast
      </Box> */}
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      analytics.BRRRR
      .refinancePropertyPayOffYears
      }
      duration={1}
      separator=","
      decimals={1}
      suffix=" yrs"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div data-tour="valueOverTime-step-2">
      <Box sx={strategyFieldLabelSx}>
      Value at payoff
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      {/* <Box sx={{
        display: "inline-block",
        py: 0,
        px: "0.7em",
        fontSize: "70%",
        fontWeight: 700,
        lineHeight: "21px",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "baseline",
        borderRadius: "100%",
        textTransform: "uppercase",
        height: 10,
        color: "#fff",
        backgroundColor: "#1bc943",
        textIndent: "-999rem",
        width: 10,
        p: 0,
        boxShadow: "0 0 0 2px #fff",
        mr: "0.5rem",
      }}>
      fast
      </Box> */}
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      analytics.BRRRR
      .refinancePropertyAppreciationValue
      }
      duration={1}
      separator=","
      decimals={0}
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid size={{ xs: 4 }}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div data-tour="valueOverTime-step-3">
      <Box sx={strategyFieldLabelSx}>
      Cashflow at payoff
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      {/* <Box sx={{
        display: "inline-block",
        py: 0,
        px: "0.7em",
        fontSize: "70%",
        fontWeight: 700,
        lineHeight: "21px",
        textAlign: "center",
        whiteSpace: "nowrap",
        verticalAlign: "baseline",
        borderRadius: "100%",
        textTransform: "uppercase",
        height: 10,
        color: "#fff",
        backgroundColor: "#f4772e",
        textIndent: "-999rem",
        width: 10,
        p: 0,
        boxShadow: "0 0 0 2px #fff",
        mr: "0.5rem",
      }}>
      normal
      </Box> */}
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      analytics.BRRRR
      .refinanceCashFlowAtPayoff
      }
      duration={1}
      delay={2}
      separator=","
      decimals={0}
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      </Grid>
      </Box>
      {analytics.BRRRR.cashFlowBRRRR >= 0 ? (
      <Box component="p"
     
      data-tour="valueOverTime-step-4" sx={strategySubtitleCenterSx}>
      If you took{' '}
      <b>
      {currencyFormat.format(
      ((analytics.BRRRR.cashFlowBRRRR / 12) *
      analytics.payDownAccelerator) /
      100,
      )}
      </b>{' '}
      ({analytics.payDownAccelerator}% of the net cashflow)
      and paid it towards the{' '}
      <Tooltip title="The amount you borrowed from the lender.">
      <Box component="span"
      sx={strategyTooltipLinkSx}
      >
      loan principal
      </Box>
      </Tooltip>{' '}
      each month, this property could be paid off in{' '}
      <b>
      {analytics.BRRRR.refinancePropertyPayOffYears.toFixed(
      1,
      )}{' '}
      years
      </b>
      {analytics.BRRRR.refinancePropertyPayOffYears.toFixed(
      1,
      ) ===
      (assumptions.refinanceTermType === 'Years'
      ? assumptions.refinanceTerm
      : assumptions.refinanceTerm / 12
      ).toFixed(1)
      ? ''
      : ` instead of ${
      assumptions.refinanceTerm
      ? (assumptions.refinanceTermType === 'Years'
      ? assumptions.refinanceTerm
      : assumptions.refinanceTerm / 12
      ).toFixed(1)
      : 0
      }`}
      .
      </Box>
      ) : (
      <Box component="p"
     
      data-tour="valueOverTime-step-4" sx={strategySubtitleCenterSx}>
      The cashflow of this property is less than zero, which
      means you can't take a percent of the cashflow and pay
      it towards the loan balance.
      </Box>
      )}
      <Divider sx={strategyBlockSpacerSx} />
      <Grid container>
      <Grid>
      <Grid
      container
      direction="row"
      spacing={1}
      sx={{
      alignItems: "center"
      }}
      >
      {map(projectionAssumptionsFields, (section) =>
      renderInputFields(section),
      )}
      {/* <Grid size={12}>
      <Typography id="continuous-slider" gutterBottom>
      Paydown Accelerator (% of net cashflow)
      </Typography>
      <Slider value={75} />
      <Grid container direction='row' justifyContent='space-between'>
      <Grid>
      <Typography id="continuous-slider" gutterBottom>
      0%
      </Typography>
      </Grid>
      <Grid>
      <Typography>100%</Typography>
      </Grid>
      </Grid>
      </Grid> */}
      </Grid>
      </Grid>
      </Grid>
      </CardContent>
      </Card>
      )},
      {
      name: 'cashPositioning',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }}>
      <Box sx={strategyMetricRowFlexSx}>
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <b>Cash Positioning</b>
      </Box>
      <div>
      <Tooltip title="Projected cash growth over one, three, five, and ten years">
      <Button
      onClick={() =>
      setOpenBRRRRCashPositioningTour(true)
      }
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </div>
      </Box>
      <Divider />
      <CardContent>
      <Suspense fallback={<LoadingSkeleton variant="chart" />}>
      <Chart options={options} series={series} type="bar" />
      </Suspense>{' '}
      <Tooltip
      title={`Total Return of ${assumptions.rentalHoldingPeriodBRRRR} years`}
      >
      <Box
      sx={{
        borderRadius: "0.65rem",
        p: 1.5,
        mb: 1,
        bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
        textAlign: "center",
        border: "1px solid rgba(59, 62, 102, 0.1)",
        "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 1.25,
          py: 0.75,
          gap: 0.25,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
        "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
          minHeight: "2.6em",
          lineHeight: 1.3,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          px: 0.5,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
          color: "#070919",
          fontWeight: 700,
          fontSize: "1.15rem",
          lineHeight: 1.2,
        },
      }}
      onClick={() => toggle1('Total Return')}
      >
      <Grid container sx={{
      justifyContent: "space-around"
      }}>
      <Grid data-tour="cashPositioning-step-1">
      <Typography>Total Return</Typography>
      <Typography>
      {currencyFormat.format(
      analytics.BRRRR.totalReturnOnInvestmentBRRRR,
      )}
      </Typography>
      </Grid>
      <Grid data-tour="cashPositioning-step-2">
      <Typography>Total Return %</Typography>
      <Typography>
      {percentageFormat.format(
      analytics.BRRRR.totalOutOfPocketBRRRR
      ? analytics.BRRRR
      .totalReturnOnInvestmentBRRRR /
      analytics.BRRRR.totalOutOfPocketBRRRR
      : 0,
      )}
      </Typography>
      </Grid>
      </Grid>
      </Box>
      </Tooltip>
      {/* <Grid container direction="row">
      <Grid size={12}>
      <Button
      variant='outlined'
      fullWidth
      onClick={handleOpenAmortization}
      >
      <Typography>Amortization</Typography>
      </Button>
      </Grid>
      </Grid> */}
      </CardContent>
      </Card>
      )},
      {
      name: 'disposition',
      card: (
      <Card variant="outlined" sx={{ width: "100%" }}>
      <Box sx={strategyMetricRowFlexSx}>
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <b>Disposition Expenses</b>
      </Box>
      <div>
      <Tooltip title="All costs and expenses associated with sale of this property">
      <Button
      onClick={() =>
      setOpenBRRRRDispositionExpensesTour(true)
      }
      sx={{
        backgroundColor: "rgba(54, 140, 255, 0.15)",
        color: "#368cff",
        borderColor: "transparent",
        "&:hover, &.active": { backgroundColor: "#368cff", color: "#fff" },
        "&:hover .btn-wrapper--icon svg path, &.active .btn-wrapper--icon svg path": { fill: "#fff" },
        height: "30px !important",
        width: "30px !important",
        lineHeight: "30px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        border: 0,
        textAlign: "left",
      }}
      >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
      </Button>
      </Tooltip>
      </div>
      </Box>
      <Divider />
      <CardContent>
      <Grid>
      <Grid>
      <Box sx={strategyFlexCenterOnlySx}>
      <Suspense fallback={<LoadingSkeleton variant="chart" />}>
      <Chart
      options={dispositionChartOptions}
      series={dispositionChartSeries}
      type="donut"
      width="300"
      />
      </Suspense>
      </Box>
      </Grid>
      <Divider sx={strategyBlockSpacerSx} />
      <Grid>
      <Grid
      container
      direction="row"
      spacing={1}
      sx={{
      alignItems: "center"
      }}
      >
      {map(dispositionFields, (field) =>
      renderInputFields(field),
      )}
      </Grid>
      </Grid>
      </Grid>
      </CardContent>
      </Card>
      )},
      {
      name: 'comparableProperties',
      card: (
      <ComparablePropertiesCard
      basicView={props.basicView}
      compData={compData}
      onComparablePropertiesTourClick={
      toggleComparablePropertiesTour
      }
      onToggleCenter={props.toggleCenter}
      determinedComps={props.determinedComps}
      compProperties={props.compProperties}
      />
      )},
      {
      name: 'piti',
      hide:
      activeOrg?.member !== 'pacemorby' &&
      activeOrg?.member !== 'astroflip',
      card: props.basicView ? null : (
      <Card variant="outlined" sx={{ width: "100%" }}>
      <Box sx={strategyMetricRowFlexSx}>
      <Box sx={{
        flexGrow: 1,
        minWidth: 0,
        "& > b": { display: "block" },
        "& > small": {
          textTransform: "uppercase",
          display: "block",
          opacity: 0.3,
          fontWeight: "bold",
        },
      }}>
      <b>Deal Sauce Summary</b>
      </Box>
      <Select
      value={dealSauceView}
      name="dealSauceView"
      onChange={(event) =>
      setDealSauceView(event.target.value)
      }
      sx={strategyFullWidthSx}
      >
      <MenuItem value="cash" key="cash">
      Cash
      </MenuItem>
      <MenuItem value="creative" key="creative">
      Creative
      </MenuItem>
      </Select>
      </Box>
      <Divider />
      <CardContent>
      {dealSauceView === 'cash' && (
      <>
      <Box sx={{
        borderRadius: "0.65rem",
        p: 1.5,
        mb: 1,
        bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
        textAlign: "center",
        border: "1px solid rgba(59, 62, 102, 0.1)",
        "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 1.25,
          py: 0.75,
          gap: 0.25,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
        "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
          minHeight: "2.6em",
          lineHeight: 1.3,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          px: 0.5,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
          color: "#070919",
          fontWeight: 700,
          fontSize: "1.15rem",
          lineHeight: 1.2,
        },
      }}>
      <Grid
      container
      sx={{ color: "rgba(59, 62, 102, 0.5)" }}
      >
      <Grid size={{md: 6}}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>
      Entry Fee
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={[strategyFlexPadSx, strategyMinHeight50Sx]}>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={cashEntryFee}
      duration={0}
      separator=","
      delay={1}
      decimals={0}
      decimal="."
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid size={{md: 6}}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>
      Max Allowable Offer
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={[strategyFlexPadSx, strategyMinHeight50Sx]}>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      analysis.afterRepairValue -
      cashEntryFee
      }
      duration={0}
      separator=","
      delay={1}
      decimals={0}
      decimal="."
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      </Grid>
      </Box>
      <Grid size={12}>
      <Grid container direction="column" spacing={4}>
      <ContactInformation property={property} />
      </Grid>
      </Grid>
      <CommentsDialog
      property={property}
      userId={props?.session?.me?._id}
      />
      <Button
      variant="contained"
      color="primary"
      fullWidth
     
      onClick={(e) => setOpenPITICashData(true)} sx={strategyMarginTop25Sx}>
      <Typography>View Cash Underwriting</Typography>
      </Button>
      </>
      )}
      {dealSauceView === 'creative' && (
      <>
      <Box sx={{
        borderRadius: "0.65rem",
        p: 1.5,
        mb: 1,
        bgcolor: "#f4f5fd", "html[data-color-mode=\"dark\"] &": { bgcolor: "#2a2a2a", borderColor: "rgba(255, 255, 255, 0.12)", "& .MuiTypography-root": { color: "rgba(255, 255, 255, 0.87) !important" } },
        textAlign: "center",
        border: "1px solid rgba(59, 62, 102, 0.1)",
        "& > .MuiGrid-container > .MuiGrid-root, &.MuiGrid-container > .MuiGrid-root": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 1.25,
          py: 0.75,
          gap: 0.25,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > div, &.MuiGrid-container > .MuiGrid-root > div": { width: "100%" },
        "& > .MuiGrid-container > .MuiGrid-root > div > div:first-of-type, &.MuiGrid-container > .MuiGrid-root > div > div:first-of-type": {
          minHeight: "2.6em",
          lineHeight: 1.3,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          px: 0.5,
          boxSizing: "border-box",
        },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:first-of-type": { color: "#4f5062", fontSize: "0.8125rem", lineHeight: 1.3 },
        "& > .MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type, &.MuiGrid-container > .MuiGrid-root > .MuiTypography-root:last-of-type": {
          color: "#070919",
          fontWeight: 700,
          fontSize: "1.15rem",
          lineHeight: 1.2,
        },
      }}>
      <Grid
      container
      sx={{ color: "rgba(59, 62, 102, 0.5)" }}
      >
      <Grid size={{md: 6}}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>
      Entry Fee
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={creativeEntryFee}
      duration={1}
      separator=","
      delay={1}
      decimals={0}
      decimal="."
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid size={{md: 6}}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>PITI</Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={pitiTotal}
      duration={1}
      separator=","
      delay={1}
      decimals={0}
      decimal="."
      prefix="$"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      <Grid size={{md: 12}}
      sx={[{ display: "flex" }, { justifyContent: "center" }]}
      >
      <div>
      <Box sx={strategyFieldLabelSx}>
      % of Purchase Price
      </Box>
      <Box sx={[strategyFlexCenterSx, { fontSize: "1.15rem !important" }]}>
      <Box sx={strategyFlexPadSx}>
      <Box component="span" sx={strategyBadgeIconSx}>
      <CountUp
      start={0}
      end={
      analysis?.offerPrice &&
      analysis.offerPrice !== 0
      ? (creativeEntryFee /
      analysis.offerPrice) *
      100
      : 0
      }
      duration={1}
      delay={1}
      decimals={2}
      decimal="."
      suffix="%"
      />
      </Box>
      </Box>
      </Box>
      </div>
      </Grid>
      </Grid>
      </Box>
      <Grid container>
      <Grid size={12}>
      <Grid container direction="column" spacing={4}>
      <ContactInformation property={property} />
      </Grid>
      </Grid>
      <CommentsDialog
      property={property}
      userId={props?.session?.me?._id}
      />
      <Button
      variant="contained"
      color="primary"
      fullWidth
     
      onClick={(e) => setOpenPITICreativeData(true)} sx={strategyMarginTop25Sx}>
      <Typography>
      View Creative Underwriting
      </Typography>
      </Button>
      </Grid>
      </>
      )}
      </CardContent>
      </Card>
      )},
      {
      name: 'deactive',
      card: <DeactiveCard />},
      ]
      const [updateProperty] = useMutation(UPDATE_PROPERTY)
      const [updateOrganization] = useMutation(UPDATE_ORGANIZATION)
      return (
      <>
      <StrategyPageBase
        cards={BRRRRCards}
        strategyName="BRRRR"
        strategyKey="BRRRR"
        property={property}
        activeOrg={activeOrg}
        canDrag={props.canDrag}
        publicDashboard={props.publicDashboard}
        publicImageCard={props.publicImageCard}
        session={props.session}
        renderInputFields={renderInputFields}
      />
      {map(calculationDialogs, (section) => (
        <Dialog
          key={section.label}
          open={modal1 === section.label}
          onClose={toggle1Close}
          maxWidth="lg"
          scroll="body"
          slotProps={{ paper: { sx: calcDialogPaperSx } }}
        >
          {/* <BlockUi blocking={loader} loader={<PacmanLoader color={'var(--primary)'} loading={true} />}> */}
          <Grid container spacing={0}>
            <Grid size={5}>
              <Box sx={[strategyFullHeight100Sx, {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                "& > .divider": { zIndex: 7, width: "100%" },
                "& .hero-footer": { zIndex: 7 },
                "& .header-nav-wrapper": { zIndex: 27 },
                "& .bg-composed-wrapper--image": { backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" },
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                alignItems: "center",
                ".MuiCard-root > &": {
                  top: -1,
                  marginLeft: -1,
                  marginRight: -1,
                  marginBottom: -2,
                  zIndex: 6,
                },
                backgroundImage: "linear-gradient(135deg, var(--hf-calc-hero-from, #CE9FFC) 10%, var(--hf-calc-hero-to, #7367F0) 100%) !important",
                  "html[data-color-mode=\"dark\"] & .MuiTypography-root": { color: "rgba(255, 255, 255, 0.92) !important" },
              }, {
                borderRadius: "0.65rem !important",
                "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
              }]}>
                <Box sx={[strategyFlexCenterRowSx, strategyFlexGrowSx]}>
                  <Box sx={[strategyNavyBgSx, {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: "100%",
                    width: "100%",
                    zIndex: 5,
                    opacity: "0.7 !important",
                  }, {
                    borderRadius: "0.65rem !important",
                    "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
                  }]} />
                  <Box sx={[{
                    justifyContent: "center",
                    "@media (min-width: 1440px)": { justifyContent: "flex-start", textAlign: "left" },
                    textAlign: "center",
                    p: "3rem",
                  }, { position: "relative", zIndex: "7", width: "100%" }]}>
                    <Box sx={strategyFooterNoteSx}>
                      <Typography sx={strategyCardTitleSx}>
                        Calculation
                      </Typography>
                    </Box>
                    {section.calculation}
                    <Box sx={strategyFooterNoteSx}>
                      <Typography>
                        * Calculation may be a few dollars off due to
                        rounding
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid size={7}>
              <div>
                <Card>
                  <CardHeader title={section.label} />
                  <Divider />
                  <CardContent sx={strategyFullHeight100Sx}>
                    <Grid
                      container
                      direction="row"
                      sx={{
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                      <Grid size={12} sx={strategyMarginBottom10Sx}>
                        <Card sx={strategyMetricGrayBgSx}>
                          <CardContent>
                            <Typography>
                              {section.description}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    <Grid container sx={{
                      justifyContent: "center"
                    }}>
                      <Grid>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={toggle1Close}
                        >
                          Close
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </div>
            </Grid>
          </Grid>
          {/* </BlockUi> */}
        </Dialog>
      ))}
      {map(financials, (section) => (
        <Dialog
          key={section.label}
          open={modal1 === section.label}
          onClose={toggle1Close}
          maxWidth="lg"
          scroll="body"
          slotProps={{ paper: { sx: calcDialogPaperSx } }}
        >
          <Grid container spacing={0}>
            <Grid size={5}>
              <Box sx={[strategyFullHeight100Sx, {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                "& > .divider": { zIndex: 7, width: "100%" },
                "& .hero-footer": { zIndex: 7 },
                "& .header-nav-wrapper": { zIndex: 27 },
                "& .bg-composed-wrapper--image": { backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" },
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
                alignItems: "center",
                ".MuiCard-root > &": {
                  top: -1,
                  marginLeft: -1,
                  marginRight: -1,
                  marginBottom: -2,
                  zIndex: 6,
                },
                backgroundImage: "linear-gradient(135deg, var(--hf-calc-hero-from, #CE9FFC) 10%, var(--hf-calc-hero-to, #7367F0) 100%) !important",
                  "html[data-color-mode=\"dark\"] & .MuiTypography-root": { color: "rgba(255, 255, 255, 0.92) !important" },
              }, {
                borderRadius: "0.65rem !important",
                "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
              }]}>
                <Box sx={[strategyFlexCenterRowSx, strategyFlexGrowSx]}>
                  <Box sx={[strategyNavyBgSx, {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: "100%",
                    width: "100%",
                    zIndex: 5,
                    opacity: "0.7 !important",
                  }, {
                    borderRadius: "0.65rem !important",
                    "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
                  }]} />
                  <Box sx={[{
                    justifyContent: "center",
                    "@media (min-width: 1440px)": { justifyContent: "flex-start", textAlign: "left" },
                    textAlign: "center",
                    p: "3rem",
                  }, { position: "relative", zIndex: "7", width: "100%" }]}>
                    <Box sx={strategyFooterNoteSx}>
                      <Typography sx={strategyCardTitleSx}>
                        Calculation
                      </Typography>
                    </Box>
                    {section.calculation}
                    <Box sx={strategyFooterNoteSx}>
                      <Typography>
                        * Calculation may be a few dollars off due to
                        rounding
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid size={7}>
              <div>
                <Card>
                  <CardHeader title={section.label} />
                  <Divider />
                  <CardContent sx={strategyFullHeight100Sx}>
                    <Grid
                      container
                      direction="row"
                      sx={{
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                      <Grid size={12} sx={strategyMarginBottom10Sx}>
                        <Card sx={strategyMetricGrayBgSx}>
                          <CardContent>
                            <Typography>
                              {section.description}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    <Grid container sx={{
                      justifyContent: "center"
                    }}>
                      <Grid>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={toggle1Close}
                        >
                          Close
                        </Button>
                      </Grid>
                    </Grid>
                  </CardActions>
                </Card>
              </div>
            </Grid>
          </Grid>
        </Dialog>
      ))}
      <Dialog
        open={openManagementCompanies}
        onClose={handleCloseManagementCompanies}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle>Property Management Companies</DialogTitle>
        <DialogContent sx={strategyPadVert15Sx}>
          <Grid container direction="column" spacing={2}>
            {map(
              filter(propertyManagementCompanies, (company) =>
                includes(
                  property.propertyManagementGroups,
                  company.value,
                ),
              ),
              (section) => (
                <Grid>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    sx={{
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}>
                    <Grid>
                      <Box data-hf="avatar-image" sx={[strategyCircleGreenAvatarSx, {
                        borderRadius: "0.65rem !important",
                        "& .blur-load": { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" },
                      }]}>
                        <Box component="img" src={section.image} alt="..." sx={{
                          maxWidth: "100%",
                          height: "100%",
                          width: "100%",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "0.29rem !important",
                        }} />
                      </Box>
                    </Grid>
                    <Grid>
                      <Typography>{section.name}</Typography>
                    </Grid>
                    <Grid>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        href={section.link}
                        target="_blank"
                      >
                        <Typography>View</Typography>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              ),
            )}
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        open={modal1 === 'Total Return'}
        onClose={toggle1Close}
        maxWidth="lg"
        scroll="body"
        slotProps={{ paper: { sx: calcDialogPaperSx } }}
      >
        <Grid container spacing={0}>
          <Grid size={5}>
            <Box sx={[strategyFullHeight100Sx, {
              position: "relative",
              display: "flex",
              flexDirection: "column",
              "& > .divider": { zIndex: 7, width: "100%" },
              "& .hero-footer": { zIndex: 7 },
              "& .header-nav-wrapper": { zIndex: 27 },
              "& .bg-composed-wrapper--image": { backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" },
              borderTopLeftRadius: "inherit",
              borderTopRightRadius: "inherit",
              alignItems: "center",
              ".MuiCard-root > &": {
                top: -1,
                marginLeft: -1,
                marginRight: -1,
                marginBottom: -2,
                zIndex: 6,
              },
              backgroundImage: "linear-gradient(135deg, var(--hf-calc-hero-from, #CE9FFC) 10%, var(--hf-calc-hero-to, #7367F0) 100%) !important",
                  "html[data-color-mode=\"dark\"] & .MuiTypography-root": { color: "rgba(255, 255, 255, 0.92) !important" },
            }, {
              borderRadius: "0.65rem !important",
              "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
            }]}>
              <Box sx={[strategyFlexCenterRowSx, strategyFlexGrowSx]}>
                <Box sx={[strategyNavyBgSx, {
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "100%",
                  zIndex: 5,
                  opacity: "0.7 !important",
                }, {
                  borderRadius: "0.65rem !important",
                  "@media (min-width: 1440px)": { borderTopRightRadius: "0 !important", borderBottomRightRadius: "0 !important" },
                }]} />
                <Box sx={[{
                  justifyContent: "center",
                  "@media (min-width: 1440px)": { justifyContent: "flex-start", textAlign: "left" },
                  textAlign: "center",
                  p: "3rem",
                }, { position: "relative", zIndex: "7", width: "100%" }]}>
                  <Box sx={strategyFooterNoteSx}>
                    <Typography sx={strategyCardTitleSx}>
                      Calculation
                    </Typography>
                  </Box>
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        Cash flow
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        {currencyFormat.format(
                          round(analytics.BRRRR.cashFlowBRRRR, 0),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        +Principal Reduction
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        +
                        {currencyFormat.format(
                          round(
                            analytics.BRRRR.principalReductionBRRRR,
                            0,
                          ),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        +Anticipated Annual Appreciation
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        +
                        {currencyFormat.format(
                          round(
                            analytics.BRRRR
                              .anticipatedAnnualAppreciationBRRRR,
                            0,
                          ),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={strategyMutedDividerSx} />
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyWhiteTextSx}>
                        Total Return
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyWhiteTextSx}>
                        {currencyFormat.format(
                          round(
                            analytics.BRRRR
                              .totalReturnOnInvestmentBRRRR,
                            0,
                          ),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        <FontAwesomeIcon
                          icon={['fal', 'divide']}
                          style={strategyIconGapStyle}
                        />
                        Total Out Of Pocket
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyMutedTextSx}>
                        <FontAwesomeIcon
                          icon={['fal', 'divide']}
                          style={strategyIconGapStyle}
                        />
                        {currencyFormat.format(
                          round(
                            analytics.BRRRR.totalOutOfPocketBRRRR,
                            0,
                          ),
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={strategyMutedDividerSx} />
                  <Grid
                    container
                    sx={[strategyMetricRowSx, {
                      alignItems: "center",
                      justifyContent: "space-between"
                    }]}>
                    <Grid>
                      <Typography sx={strategyWhiteTextSx}>
                        Total Return %
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography sx={strategyWhiteTextSx}>
                        {percentageFormat.format(
                          analytics.BRRRR.totalOutOfPocketBRRRR
                            ? analytics.BRRRR
                                .totalReturnOnInvestmentBRRRR /
                                analytics.BRRRR.totalOutOfPocketBRRRR
                            : 0,
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Box sx={strategyFooterNoteSx}>
                    <Typography>
                      * Calculation may be a few dollars off due to
                      rounding
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={7}>
            <div>
              <Card>
                <CardHeader title="Total Return" />
                <Divider />
                <CardContent sx={strategyFullHeight100Sx}>
                  <Grid
                    container
                    direction="row"
                    sx={{
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                    <Grid size={12} sx={strategyMarginBottom10Sx}>
                      <Card sx={strategyMetricGrayBgSx}>
                        <CardContent>
                          <Typography>
                            The actual rate of return of an investment
                            over a given evaluation period which
                            includes income and appreciation.
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </CardContent>
                <Divider />
                <CardActions>
                  <Grid container sx={{
                    justifyContent: "center"
                  }}>
                    <Grid>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={toggle1Close}
                      >
                        Close
                      </Button>
                    </Grid>
                  </Grid>
                </CardActions>
              </Card>
            </div>
          </Grid>
        </Grid>
      </Dialog>

      <AmortizationDialog
        open={openAmortization}
        onClose={handleCloseAmortization}
        tableHeaders={tableHeaders}
        amortizationData={amortizationData}
        currencyFormat2={currencyFormat2}
        assumptions={assumptions}
        showAdditionalPrincipal={false} // Pass false to not render the additional principal cell
      />
      <SubtoPITICash
        open={openPITICashData}
        onClose={() => setOpenPITICashData(false)}
        propertyId={property?._id}
        address={property?.address}
        city={property.city}
        state={property.state}
        zipcode={property?.zip}
      />
      <SubtoPITICreative
        open={openPITICreativeData}
        onClose={() => setOpenPITICreativeData(false)}
        propertyId={property?._id}
        address={property?.address}
        city={property.city}
        state={property.state}
        zipcode={property?.zip}
      />

      <BRRRRStrategyTour
        isOpenBRRRRStrategyTour={openStrategyTour}
        closeBRRRRStrategyTour={closeStrategyTour}
      />
      <BRRRRTargetsTour
        isOpenBRRRRTargetsTour={openTargetsTour}
        closeBRRRRTargetsTour={closeTargetsTour}
      />
      <BRRRRMonthlyCashflowTour
        isOpenBRRRRMonthlyCashflowTour={openBRRRRMonthlyCashflowTour}
        closeBRRRRMonthlyCashflowTour={() =>
          setOpenBRRRRMonthlyCashflowTour(false)
        }
      />
      <BRRRRAcquisitionExpensesTour
        isOpenBRRRRAcquisitionExpensesTour={
          openBRRRRAcquisitionExpensesTour
        }
        closeBRRRRAcquisitionExpensesTour={() =>
          setOpenBRRRRAcquisitionExpensesTour(false)
        }
      />
      <BRRRRGrossMonthlyIncomeTour
        isOpenBRRRRGrossMonthlyIncomeTour={
          openBRRRRGrossMonthlyIncomeTour
        }
        closeBRRRRGrossMonthlyIncomeTour={() =>
          setOpenBRRRRGrossMonthlyIncomeTour(false)
        }
      />
      <BRRRRMonthlyExpensesTour
        isOpenBRRRRMonthlyExpensesTour={openBRRRRMonthlyExpensesTour}
        closeBRRRRMonthlyExpensesTour={() =>
          setOpenBRRRRMonthlyExpensesTour(false)
        }
      />
      <BRRRRRehabExpensesTour
        isOpenBRRRRRehabExpensesTour={openBRRRRRehabExpensesTour}
        closeBRRRRRehabExpensesTour={() =>
          setOpenBRRRRRehabExpensesTour(false)
        }
      />
      <BRRRRBridgeLoanTour
        isOpenBRRRRBridgeLoanTour={openBRRRRBridgeLoanTour}
        closeBRRRRBridgeLoanTour={() =>
          setOpenBRRRRBridgeLoanTour(false)
        }
      />
      <BRRRRRefinanceLoanTour
        isOpenBRRRRRefinanceLoanTour={openBRRRRRefinanceLoanTour}
        closeBRRRRRefinanceLoanTour={() =>
          setOpenBRRRRRefinanceLoanTour(false)
        }
      />
      <BRRRRValueOverTimeTour
        isOpenBRRRRValueOverTimeTour={openBRRRRValueOverTimeTour}
        closeBRRRRValueOverTimeTour={() =>
          setOpenBRRRRValueOverTimeTour(false)
        }
      />
      <BRRRRCashPositioningTour
        isOpenBRRRRCashPositioningTour={openBRRRRCashPositioningTour}
        closeBRRRRCashPositioningTour={() =>
          setOpenBRRRRCashPositioningTour(false)
        }
      />
      <BRRRRDispositionExpensesTour
        isOpenBRRRRDispositionExpensesTour={
          openBRRRRDispositionExpensesTour
        }
        closeBRRRRDispositionExpensesTour={() =>
          setOpenBRRRRDispositionExpensesTour(false)
        }
      />
      <BRRRRComparablePropertiesTour
        isOpenBRRRRComparablePropertiesTour={openComparablePropertiesTour}
        closeBRRRRComparablePropertiesTour={closeComparablePropertiesTour}
      />
    </>
  );
}

export default withSession(CenterPageBRRRR)
